
export const servicesData = [
  {
    "id": "ct-scan",
    "name": "CT Scan",
    "icon": "Scan",
    "description": "Advanced multi-slice CT scanning for detailed cross-sectional imaging",
      "image": "https://apexmrictscan.in/wp-content/uploads/2020/06/ctscan-service-1-770x635.jpg",
      "details": "CT Scan is a “Medical Imaging Technique” specifically used for obtaining detailed “Internal Images” of the human body. It helps to perform and diagnose tumors, investigate internal bleeding, or check for other internal injuries or damage. It is also used for a tissue or fluid biopsy.",
      "keyFeatures": [
        "Multi-detector technology for faster scanning",
        "Low radiation dose protocols",
        "High-resolution image reconstruction",
        "3D and multiplanar reconstruction capabilities",
        "Contrast-enhanced imaging options",
        "Expert radiologist interpretation"
      ],
      "subServices": [
        {
          "name": "CT Brain",
          "duration": "15-20 mins",
          "preparation": "No special preparation required",
          "image": "https://images.pexels.com/photos/7089020/pexels-photo-7089020.jpeg",
          "description": "Comprehensive imaging of brain structures for neurological assessment",
         "detailedDescription": [
  "Rapid detection of brain hemorrhages and strokes",
  "Detailed elements to this array above visualization of brain tumors and lesions",
  "Assessment of skull fractures and traumatic injuries",
  "Evaluation of hydrocephalus and brain atrophy",
  "Pre-surgical planning and navigation",

  "Head Injuries, bleeding, stroke, brain tumors, dizziness, severe headache, and other brain-related disorders are assessed by Computed Tomography of Brain (CT Brain).",
  "CT Brain helps to detect any internal injuries or internal bleeding.",
  "In the case of Brain stroke, CT is much critical and it detects early stroke ( paralysis) and early treatment can be initiated.",
  "CT Brain helps doctors to evaluate the face, skull, sinuses, etc.",
  "Detailed information is gathered by performing CT Brain.",
  "It is a simple scan done by lying on the table. Very thin images of the brain are generated.",
  "These views are transmitted to the computer which displays the images of the internal parts of the brain on your computer.",
  "Contrast may or may not be given to the patient. The advice is given by the Doctors depending up on the need of the diagnosis.",
  "Contrast injection helps in better delineation of structures or disease and helps in making diagnosis.",
  "A qualified technician, performs the scan which takes approximately 15-35 minutes to perform a CT Brain scan.",
  "CT Scan of Brain is a cost-effective way of studying and diagnosing the internal part of the brain."
],
          "keyBenefits": [
            "Quick diagnosis in emergency situations",
            "Non-invasive brain assessment",
            "Accurate detection of minute abnormalities",
            "Guidance for surgical interventions"
          ],
        "faqs": [
  {
    "question": "Is a Brain CT Scan safe?",
    "answer": "Yes, CT scans are generally safe with minimal radiation exposure. Our modern equipment uses low-dose protocols and the benefits of accurate diagnosis typically outweigh the minimal risks."
  },
  {
    "question": "How long does the procedure take?",
    "answer": "The actual scanning time is about 5-10 minutes, but you should allow 15-20 minutes for the entire process including preparation and positioning."
  },
  {
    "question": "Will I need contrast dye?",
    "answer": "Depending on your condition, contrast dye might be used to enhance image quality. This will be determined by your referring physician."
  },
  {
    "question": "Which brain disorders can assessed by a CT Scan Brain ?",
    "answer": "Head Injuries, bleeding, stroke, brain tumors, dizziness, severe headache, and other brain-related disorders are assessed by  Computed Tomography of Brain (CT Brain)."
  },
  {
    "question": "What does a CT Scan Brain detect ?",
    "answer": "CT Brain helps to detect any internal injuries  or internal bleeding. In the case of Brain stroke, CT is much critical and it detects early stroke ( paralysis) and early treatment can be initiated."
  },
  {
    "question": "How much time required for CT Brain ?",
    "answer": "A qualified technician, performs the scan which takes approximately 15-35 minutes to perform a CT Brain scan."
  }
]
        },
        {
          "name": "ORBIT CT Scan",
          "duration": "10-15 mins",
          "preparation": "Remove eye makeup and contact lenses",
          "image": "https://images.pexels.com/photos/4226264/pexels-photo-4226264.jpeg",
          "description": "Detailed imaging of orbital structures and eye sockets",
          "detailedDescription": [
  "Detailed evaluation of orbital fractures",
  "Detection of foreign bodies in the orbit",
  "Assessment of orbital tumors and masses",
  "Evaluation of thyroid eye disease",
  "Pre-surgical planning for orbital surgeries",

  "An imaging technique used to diagnose various diseases of eye globe (orbit) is known as CT ORBIT.",
  "This technique is useful in creating thin images of the eyes and the surrounding area or bones of the orbit from three different angels.",
  "It is advised when there is any internal eye injury, or any foreign object that has gone in the eye socket.",
  "CT Orbit can be done Plain or with Contrast as required.",
  "Contrast is given through veins for better delineation of pathology.",
  "CT Orbit Contrast helps to give clear images of the Orbit.",
  "No preparation is required for plain scan. For contrast study fasting for at least 4 hours is essential.",
  "CT Orbit is performed by a qualified and experienced technician, which may take about 05-15 minutes."
],

          "keyBenefits": [
            "Precise localization of orbital pathologies",
            "Non-invasive alternative to exploratory surgery",
            "Detailed bony anatomy visualization",
            "Accurate surgical planning"
          ],
          "faqs": [
            {
              "question": "Why is ORBIT CT done?",
              "answer": "It helps diagnose eye-related trauma, tumors, infections, thyroid eye disease, and structural abnormalities in the orbital cavity that cannot be assessed by routine eye examination."
            },
            {
              "question": "Is it safe for the eyes?",
              "answer": "Yes, the radiation exposure is minimal and focused on the orbital area. Protective measures are taken to ensure safety."
            },
            {
    "question": "What is CT Orbit ?",
    "answer": "An imaging technique used to diagnose various diseases of eye globe (orbit) is known as CT ORBIT."
  },
  {
    "question": "Which Preparation required for CT Orbit ?",
    "answer": "No preparation is required for plain scan. For contrast study fasting for at least 4 hours is essential."
  },
  {
    "question": "How does a CT create Images ?",
    "answer": "This technique is useful in creating thin images of the eyes and the surrounding area or bones of the orbit from three different angels."
  },
  {
    "question": "How Long is a CT Orbit Test ?",
    "answer": "CT Orbit is performed by a qualified and experienced technician, which may take about 05-15 minutes."
  }
          ]
        },
        {
          "name": "CT/PNS (Paranasal Sinuses)",
          "duration": "10 mins",
          "preparation": "No special preparation required",
          "image": "https://images.pexels.com/photos/6501918/pexels-photo-6501918.jpeg",
          "description": "Comprehensive imaging of sinus cavities and nasal structures",
          "detailedDescription": [
  "Detailed assessment of sinus anatomy",
  "Detection of sinusitis and polyps",
  "Evaluation of nasal obstruction causes",
  "Pre-surgical planning for FESS",
  "Assessment of sinus tumors",

  "PNS means Paranasal Sinuses.",
  "Para nasal sinuses are air filled cavities around the nose that are present behind cheek bone, lower forehead,  upper nose.",
  "CT PNS is performed in order to examine the diseases / deviation of nasal septum/ chronic nasal discharge/ recurrent sinusitis/ post operative cases/ trauma and  other disorders related to the PNS.",
  "No preparations is required as it is a plain scan.",
  "It takes only about 20–30 minutes to perform the scan."
],

          "keyBenefits": [
            "Clear visualization of sinus drainage pathways",
            "Accurate diagnosis of chronic sinus conditions",
            "Guidance for endoscopic sinus surgery",
            "Detection of hidden sinus pathologies"
          ],
          "faqs": [
            {
              "question": "What conditions can CT/PNS detect?",
              "answer": "Sinusitis, nasal polyps, sinus tumors, fractures, congenital sinus abnormalities, and complications of sinus infections that may require surgical intervention."
            },
            {
              "question": "Is contrast always required?",
              "answer": "No, for routine sinus evaluation, contrast is not usually required. It may be used if there is suspicion of tumors or infections."
            },
            {
    "question": "What is PNS",
    "answer": "PNS means Paranasal Sinuses. Para nasal sinuses are air filled cavities around the nose that are present behind cheek bone, lower forehead,  upper nose."
  },
  {
    "question": "What is Full form of CT Scan PNS",
    "answer": "Full form of CT Scan PNS ( Computed Tomography scan of the Paranasal Sinuses)."
  },
  {
    "question": "Which preparation required for CT PNS",
    "answer": "No preparations is required as it is a plain scan."
  },
  {
    "question": "How much time required for CT PNS ?",
    "answer": "It takes only 10-20 minutes to perform the scan."
  }
          ]
        },
        {
          "name": "HRCT CHEST",
          "duration": "15-20 mins",
          "preparation": "Remove metal objects, fasting may be required if contrast is used",
          "image": "https://www.shutterstock.com/image-photo/multi-slice-ct-scan-chest-260nw-2345335587.jpg",
          "description": "High-resolution lung imaging for interstitial lung diseases",
          "detailedDescription": [
  "Superior visualization of lung architecture",
  "Early detection of interstitial lung diseases",
  "Assessment of bronchiectasis pattern",
  "Evaluation of occupational lung diseases",
  "Monitoring treatment response",

  "HRCT means high resolution computed tomography.",
  "Diagnosing and assessment of interstitial lung disease, like pulmonary fibrosis, and other generalized lung diseases such as emphysema and bronchiectasis is known as High-resolution computed tomography (HRCT).",
  "HRCT chest examines the entire lung parenchyma.",
  "It helps to diagnose the disorders or diseases related to Lungs like bronchial asthma, allergic diseases, lung cancer,  infections and  injuries.",
  "Through HRCT very thin ( 1 mm) slice high resolution  images are created.",
  "It takes only about 05–15 minutes to perform the same.",
  "It is a simple and painless scan.",
  "HRCT chest is very useful in diagnosing Covid -19 pneumonia.",
  "It detects complications of Covid at the early stage."
],

          "keyBenefits": [
            "Early detection of lung fibrosis",
            "Detailed airway anatomy assessment",
            "Accurate characterization of lung patterns",
            "Monitoring disease progression over time"
          ],
          "faqs": [
            {
              "question": "What makes HRCT different from regular chest CT?",
              "answer": "HRCT uses thinner slices (1-2 mm vs 5 mm), special reconstruction algorithms, and targeted imaging protocols specifically designed for detailed lung tissue analysis."
            },
            {
              "question": "Do I need to hold my breath during the scan?",
              "answer": "Yes, you'll be asked to hold your breath for 10-20 seconds during the scan to prevent motion artifacts and ensure clear images."
            },
            {
    "question": "What is the difference between CT HRCT plain & Contrast?",
    "answer": "HRCT scans do not use contrast"
  },
  {
    "question": "How long does a plain CT scan take?",
    "answer": "The output normally requires somewhere in the range of 15 and 30 minutes. There are no limitations following the test. You will actually want to get back to ordinary exercises, eat not surprisingly, and drive yourself home."
  },
  {
    "question": "What preparation is required for a CT scan?",
    "answer": "No special preparation is required"
  }
          ]
        },
        {
          "name": "CT Abdomen & Pelvis",
          "duration": "20-25 mins",
          "preparation": "6 hours fasting, oral contrast required 1 hour before scan",
          "image": "https://media.istockphoto.com/id/1218753202/photo/mri-scan-human-abdominal-tomography.jpg?b=1&s=612x612&w=0&k=20&c=y8HJp80U6dkEnwY89UttbWNV96AsTInO5nUBppHnEOY=",
          "description": "Comprehensive imaging of abdominal and pelvic organs",
          "detailedDescription": [
  "Complete abdominal and pelvic assessment",
  "Multi-phase contrast enhancement",
  "Accurate cancer staging and follow-up",
  "Trauma evaluation in emergency settings",
  "Comprehensive inflammatory bowel disease assessment",

  "An imaging technique used to examine the abdomen and pelvis through computed tomography is known as CT Abdomen Pelvis.",
  "CT Abdominal Pelvis helps to diagnose diseases related to the abdomen.",
  "It helps to detect hernia, kidney stone, tumors, infections, obstructions and any other abdominal related issues.",
  "Prior to 5 hrs, when the scan is going to be performed, one should not eat.",
  "It takes only about 30–60 minutes to perform the same.",
  "It is a simple and painless scan."
],

          "keyBenefits": [
            "One-stop evaluation of entire abdomen and pelvis",
            "Accurate tumor detection and staging",
            "Comprehensive trauma assessment",
            "Detailed organ-specific evaluation"
          ],
          "faqs": [
            {
              "question": "Why is fasting required?",
              "answer": "Fasting helps ensure your stomach and intestines are empty, providing clearer images and reducing the risk of aspiration if contrast is used."
            },
            {
              "question": "How long does the contrast take to work?",
              "answer": "Oral contrast takes about 45-60 minutes to travel through your digestive system and provide optimal imaging quality."
            },
              {
    "question": "Is CT Abdomen pelvis Safe?",
    "answer": "Yes, it is generally safe. Modern CT scanners use low-dose radiation and the diagnostic benefits outweigh the minimal risks."
  },
  {
    "question": "What is the difference between CT Abdomen pelvis plain & Contrast?",
    "answer": "Plain CT shows basic structures, while contrast-enhanced CT highlights organs, blood vessels and abnormalities more clearly."
  },
  {
    "question": "How long does a plain CT scan take?",
    "answer": "A plain CT Abdomen Pelvis scan usually takes about 10–20 minutes."
  },
  {
    "question": "What preparation is required for a CT Abdomen pelvis?",
    "answer": "You may be asked to avoid eating for 4–5 hours before the scan. Other instructions depend on whether contrast is needed."
  }
          ]
        },
        {
          "name": "CT Pulmonary Angiography",
          "duration": "15-20 mins",
          "preparation": "Fasting required, IV contrast essential",
          "image": "https://media.istockphoto.com/id/1697076756/photo/ctpa-or-cta-pulmonary-artery-for-diagnostic-pulmonary-embolism-lung-cancer-and-covid-19.jpg?b=1&s=612x612&w=0&k=20&c=Lnq7tnokfSLzPXPG0Yq5KtwqNEYpd7lddJuCcQ8hHac=",
          "description": "Imaging of pulmonary arteries to detect blood clots",
          "detailedDescription": [
            "Gold standard for pulmonary embolism diagnosis",
            "Detailed visualization of pulmonary arteries",
            "Assessment of right heart strain",
            "Evaluation of pulmonary hypertension",
            "Detection of vascular anomalies",
             "An imaging technique in which, images are created using radiation technique which shows blood vessels going from the arteries to the lungs is known as CT Pulmonary Angiography.",
  "A contrast is given through veins in the form of injection, which passes through the arteries.",
  "It helps to detect blood clots in the lungs.",
  "During the scan, the heart rate, blood pressure, and breathing are observed.",
  "It is done in order to check the blood flow before or post-surgery.",
  "Before 3 hours, when the scan is going to be performed, one should not eat.",
  "It takes only about 15–30 minutes to perform the same."
          ],
          "keyBenefits": [
            "Rapid diagnosis of life-threatening conditions",
            "High accuracy in clot detection",
            "Non-invasive alternative to conventional angiography",
            "Comprehensive pulmonary vascular assessment"
          ],
          "faqs": [
            {
              "question": "What symptoms require CTPA?",
              "answer": "Sudden chest pain, shortness of breath, coughing blood, rapid heart rate, and suspected pulmonary embolism."
            },
            {
              "question": "How quickly can results be obtained?",
              "answer": "In emergency situations, preliminary results can be available within 30 minutes to guide immediate treatment."
            },
             {
    "question": "Is CT Pulmonary Angiography Safe?",
    "answer": "Yes, it is generally safe. Modern scanners use low-dose radiation, and the contrast is carefully monitored by medical staff."
  },
  {
    "question": "How long does a CT Pulmonary Angiography take?",
    "answer": "The scan usually takes about 15–30 minutes."
  },
  {
    "question": "What preparation is required for a CT Pulmonary Angiography test?",
    "answer": "You may be asked to avoid eating for about 3 hours before the test. Other instructions depend on the use of contrast."
  }
          ]
        },
        {
          "name": "CT Aortic Angiography",
          "duration": "20-25 mins",
          "preparation": "Fasting required, IV contrast essential",
          "image": "https://media.istockphoto.com/id/1213201733/photo/coronary-angiography.jpg?s=612x612&w=0&k=20&c=PV6rK-oqy-RvtrvCFJEkL12COTfKhWWtvaydTVagp2A=",
          "description": "Detailed imaging of aorta for vascular conditions",
          "detailedDescription": [
            "Comprehensive evaluation of entire aorta",
            "Detection of aortic aneurysms and dissections",
            "Assessment of aortic trauma",
            "Evaluation of congenital aortic abnormalities",
            "Pre-surgical planning for aortic repairs",
              "An imaging technique in which, images are created using radiation technique showing blood flow from the largest artery named as Aorta (Aorta carries blood from the heart to the circulatory system), is known as CT Aortic Angiography.",
  "It uses a special (Contrast) to examine the Aorta.",
  "CT Aortic Angiography is advised when there are Aortic symptoms like pain in the chest, neck, low blood pressure, shortness of breath, difficulty in breathing etc.",
  "It takes only about 15–30 minutes to perform the same."
          ],
          "keyBenefits": [
            "Life-saving diagnosis of aortic emergencies",
            "Accurate measurement of aortic dimensions",
            "Detailed pre-surgical mapping",
            "Non-invasive vascular assessment"
          ],
          "faqs": [
            {
              "question": "What is aortic dissection?",
              "answer": "A life-threatening condition where the inner layer of aorta tears, causing blood to flow between layers, which can lead to rupture if not treated immediately."
            },
            {
              "question": "Who is at risk for aortic aneurysms?",
              "answer": "People with hypertension, smokers, those with family history, and patients with connective tissue disorders are at higher risk."
            },
             {
    "question": "Is CT Aortic Angiography Safe?",
    "answer": "Yes, it is generally safe. Modern CT scanners use low radiation doses, and the contrast is given under medical supervision."
  },
  {
    "question": "How long does a CT Aortic Angiography take?",
    "answer": "The scan usually takes about 15–30 minutes."
  },
  {
    "question": "What preparation is required for a CT Aortic Angiography?",
    "answer": "You may be asked to avoid eating for a few hours before the scan. Additional instructions depend on your medical condition."
  }
          ]
        },
        {
          "name": "CT Renal Angiography",
          "duration": "15-20 mins",
          "preparation": "Fasting required, IV contrast essential",
          "image": "https://media.istockphoto.com/id/1005170798/photo/cta-abdominal-aorta-and-femoral-run-off-3d-rendering-image.jpg?s=612x612&w=0&k=20&c=5VRT8F4vUSwgQhukNjdPZdSEG5sO-W2tULuDhr0Haeg=",
          "description": "Imaging of renal arteries and kidneys",
          "detailedDescription": [
            "Evaluation of renal artery stenosis",
            "Assessment of kidney tumors and masses",
            "Detection of vascular malformations",
            "Hypertension workup and assessment",
            "Pre-transplant donor evaluation",
             "An imaging technique in which, images are created using radiation technique showing blood flow from the arteries to the kidney is known as CT Renal Angiography.",
  "A contrast is given through veins in the form of injection, which passes through the arteries.",
  "This scan helps doctors to look for blockages of blood narrowing of the blood vessels, is the blood flow proper to the kidney or ballooning of the blood vessels.",
  "It takes only about 30–90 minutes to perform the same."
          ],
          "keyBenefits": [
            "Non-invasive renal vascular assessment",
            "Accurate detection of renovascular hypertension",
            "Comprehensive kidney tumor evaluation",
            "Detailed pre-surgical planning"
          ],
          "faqs": [
            {
              "question": "Who needs renal angiography?",
              "answer": "Patients with uncontrolled hypertension, renal failure, suspected renal artery stenosis, kidney tumors, or being evaluated as kidney donors."
            },
            {
              "question": "Can it detect kidney stones?",
              "answer": "While it can detect stones, CT KUB is more specific for stone evaluation. Renal angiography focuses on blood vessels and tumors."
            },
             {
    "question": "Is CT Renal Angiography Safe?",
    "answer": "Yes, it is generally safe. Radiation exposure is low, and contrast is administered under medical supervision."
  },
  {
    "question": "How long does a CT Renal Angiography take?",
    "answer": "The procedure typically takes about 30–90 minutes."
  },
  {
    "question": "What preparation is required for a CT Renal Angiography ?",
    "answer": "You may be asked to avoid eating for a few hours before the scan. Additional instructions may depend on kidney function and contrast use."
  }
          ]
        },
        {
          "name": "CT Brain Angiography",
          "duration": "15-20 mins",
          "preparation": "Fasting required, IV contrast essential",
          "image": "https://media.istockphoto.com/id/1161205745/photo/mra-brain-axial-mip-view-showing-vessel-in-the-brain-name-is-circle-of-willis.jpg?s=612x612&w=0&k=20&c=wTYekmeZQx3SokUugcqRVDdWgM5zi4qVWHxNhkf1Hvc=",
          "description": "Detailed imaging of cerebral blood vessels",
          "detailedDescription": [
            "Detection of cerebral aneurysms",
            "Evaluation of arteriovenous malformations",
            "Assessment of vasculitis and vascular diseases",
            "Stroke evaluation and assessment",
            "Pre-surgical vascular mapping"
          ],
          "keyBenefits": [
            "Non-invasive cerebral vascular assessment",
            "Early detection of aneurysm before rupture",
            "Detailed stroke cause identification",
            "Accurate surgical planning",
            "An imaging technique in which, images are created using the radiations technique which shows blood vessels going from the arteries to the brain is known as CT Brain Angiography.",
  "A contrast is given through veins in the form of injection, which passes through the arteries.",
  "This scan is used to check abnormalities in the brain like a blood clot, brain tumors, a stroke, a tear in the wall of the arteries, or a narrowing of the arteries.",
  "It takes only about 15–30 minutes to perform the same."
          ],
          "faqs": [
            {
              "question": "Can it detect brain aneurysms?",
              "answer": "Yes, it's highly sensitive for detecting cerebral aneurysms, AV malformations, and vascular abnormalities that could lead to stroke."
            },
            {
              "question": "Is it better than conventional angiography?",
              "answer": "It's less invasive with lower complication risks, though conventional angiography may be needed for certain therapeutic procedures."
            },
              {
    "question": "Is CT Brain Angiography Safe?",
    "answer": "Yes, it is generally safe. Radiation is minimal and contrast is given under medical supervision."
  },
  {
    "question": "How long does a CT Brain Angiography take?",
    "answer": "It usually takes around 15–30 minutes."
  },
  {
    "question": "What preparation is required for a CT Brain Angiography ?",
    "answer": "You may be asked to avoid eating for a few hours before the scan. Additional instructions depend on whether contrast is used."
  }
          ]
        },
        {
          "name": "CT Neck Angiography",
          "duration": "15-20 mins",
          "preparation": "Remove neck jewelry, fasting required",
          "image": "https://media.istockphoto.com/id/505024888/photo/carotid-artery-disease.jpg?s=612x612&w=0&k=20&c=4W7NWul1OgC3ooPeC49-R5ML0qKWTERuyfaswJXQSYg=",
          "description": "Imaging of neck vessels for stroke prevention",
          "detailedDescription": [
            "Evaluation of carotid and vertebral arteries",
            "Detection of carotid artery stenosis",
            "Assessment of neck trauma and injuries",
            "Evaluation of neck tumors and masses",
            "Pre-surgical planning for neck surgeries",
            "An imaging technique in which images are created using radiation to show blood vessels running from the arteries in the neck to the brain is known as CT Neck Angiography.",
  "A contrast dye is injected through a vein, which passes through the arteries to highlight the blood vessels.",
  "This scan helps detect blockages, narrowing of arteries, tumors, infections, or other neck-related disorders.",
  "It takes only about 15–30 minutes to perform the scan."
          ],
          "keyBenefits": [
            "Stroke risk assessment and prevention",
            "Non-invasive carotid disease evaluation",
            "Comprehensive neck vasculature assessment",
            "Accurate tumor-vessel relationship mapping"
          ],
          "faqs": [
            {
              "question": "Why is neck angiography important?",
              "answer": "It helps prevent strokes by detecting carotid artery stenosis, dissections, and other vascular abnormalities that can cause reduced blood flow to the brain."
            },
            {
              "question": "What percentage of stenosis requires treatment?",
              "answer": "Typically, stenosis greater than 70% may require intervention, but this decision is made by your vascular specialist based on multiple factors."
            },
             {
    "question": "Is CT Neck Angiography Safe?",
    "answer": "Yes, CT Neck Angiography is generally safe. Minor reactions to contrast dye may occur, but serious complications are rare. Doctors review your kidney function and allergy history before the scan for safety."
  },
  {
    "question": "How long does a CT Neck Angiography take?",
    "answer": "The entire procedure usually takes about 15–30 minutes, depending on preparation and positioning."
  },
  {
    "question": "What preparation is required for a CT Neck Angiography?",
    "answer": "You may need to avoid eating or drinking for a few hours before the scan. Inform the radiology team about any allergies, especially to contrast dye, and bring recent kidney function tests if available. Remove any metal objects or jewelry around the neck."
  }
          ]
        },
        {
          "name": "CT Urography",
          "duration": "25-30 mins",
          "preparation": "Fasting required, IV contrast essential",
          "image": "https://media.istockphoto.com/id/1483865492/photo/cta-renal-artery-3d-rendering-image-showing-both-kidney-ureter-and-bladder.jpg?s=612x612&w=0&k=20&c=wu_Y68JWIxV2-N2AA1LEizjfPtICFXWIHJXtATNrFKs=",
          "description": "Comprehensive imaging of urinary system",
          "detailedDescription": [
            "Complete evaluation of kidneys, ureters, and bladder",
            "Detection of urinary tract tumors",
            "Assessment of kidney stones and obstructions",
            "Evaluation of congenital abnormalities",
            "Hematuria (blood in urine) workup",
              "An imaging technique that examines the urinary tract, including proper functioning of the kidneys, ureters, and bladder, is known as CT Urography.",
  "A contrast is given through veins to create clear and detailed images of the urinary system.",
  "Doctors recommend this scan to detect urinary disorders such as kidney and bladder stones, urinary tract infections, or masses in the kidney.",
  "One should avoid eating for at least 3 hours before the scan.",
  "The scan takes about 60–90 minutes to complete."
          ],
          "keyBenefits": [
            "Comprehensive urinary tract assessment",
            "Accurate tumor detection and staging",
            "Detailed anatomical and functional information",
            "One-stop urinary system evaluation"
          ],
          "faqs": [
            {
              "question": "What can CT urography detect?",
              "answer": "Kidney stones, urinary tract tumors, obstructions, infections, congenital abnormalities, and causes of unexplained blood in urine."
            },
            {
              "question": "How is it different from CT KUB?",
              "answer": "CT urography includes contrast and multiple phases to evaluate both anatomy and function, while CT KUB is non-contrast and mainly for stones."
            },
             {
    "question": "Is CT Urography Safe?",
    "answer": "Yes, CT Urography is generally safe. Mild reactions to contrast may occur, but serious complications are rare. Your doctor will check your kidney function and allergy history to ensure safety before the scan."
  },
  {
    "question": "How long does a CT Urography take?",
    "answer": "A CT Urography scan usually takes about 60–90 minutes, including preparation and imaging time."
  },
  {
    "question": "What preparation is required for a CT Urography?",
    "answer": "You should avoid eating for at least 3 hours before the scan. Inform the radiology team if you have any allergies, especially to contrast dye, and share recent kidney function test results if available."
  }
          ]
        },
        {
          "name": "CT Lower Limb Angiography",
          "duration": "20-25 mins",
          "preparation": "Fasting required, IV contrast essential",
          "image": "https://media.istockphoto.com/id/1135991918/photo/cta-femoral-artery-run-off-3d-mip-image-of-femoral-artery-with-both-kidney-from-ct-scanner.jpg?s=612x612&w=0&k=20&c=rOx4KlJJ3d6gSc4ZZjcAWJjEOUy_yFEKIoo5Wz9cHbI=",
          "description": "Imaging of blood vessels in legs",
          "detailedDescription": [
            "Evaluation of peripheral arterial disease",
            "Detection of deep vein thrombosis",
            "Assessment of arterial blockages and stenosis",
            "Evaluation of leg trauma and injuries",
            "Pre-surgical planning for vascular procedures",
             "An imaging technique that examines the blood vessels going from the arteries to the legs (lower part of the body from the hip to the toes) is known as CT Lower Limb Angiography.",
  "A contrast is given through veins to create clear images of the lower limbs.",
  "The lower limb includes the hip, bones of the thigh, knee, ankle, legs, and foot.",
  "Doctors recommend this scan when there are symptoms like numbness, cold legs or feet, muscle pain in thighs, or other leg-related issues.",
  "The scan takes about 1–3 hours to complete."
          ],
          "keyBenefits": [
            "Comprehensive leg vascular assessment",
            "Non-invasive alternative to conventional angiography",
            "Accurate detection of blood clots",
            "Detailed surgical planning"
          ],
          "faqs": [
            {
              "question": "What symptoms require this scan?",
              "answer": "Leg pain while walking, non-healing ulcers, cold feet, swelling, color changes, and suspected blood clots or peripheral arterial disease."
            },
            {
              "question": "Can it detect both arteries and veins?",
              "answer": "Yes, it can evaluate both arterial and venous systems in the lower limbs, though protocols may be optimized for one or the other."
            },
              {
    "question": "Is CT Lower Limb Angiography Safe?",
    "answer": "Yes, CT Lower Limb Angiography is generally safe. Minor reactions to contrast may occur, but serious complications are rare."
  },
  {
    "question": "How long does a CT Lower Limb Angiography take?",
    "answer": "The scan usually takes about 1–3 hours, depending on the area being imaged and patient preparation."
  },
  {
    "question": "What preparation is required for a CT Lower Limb Angiography?",
    "answer": "You may be asked to avoid eating for a few hours before the scan. Inform the medical team about any allergies or kidney issues, especially regarding contrast dye."
  }
          ]
        },
        {
          "name": "CT Upper Limb Angiography",
          "duration": "20-25 mins",
          "preparation": "Fasting required, IV contrast essential",
          "image": "https://media.istockphoto.com/id/1442166163/photo/cta-brachial-artery-or-ct-scan-of-upper-extremity-3d-rendering-image.jpg?s=612x612&w=0&k=20&c=DSjs3BD4T7DvqnkgxN6fI04Q-WHtnwumPZ_ODhfsdVs=",
          "description": "Imaging of blood vessels in arms",
          "detailedDescription": [
            "Evaluation of upper limb arterial diseases",
            "Assessment of thoracic outlet syndrome",
            "Detection of vascular trauma and injuries",
            "Evaluation of dialysis access fistulas",
            "Pre-surgical planning for arm surgeries",
            "An imaging technique that examines the blood vessels going from the arteries to the hands (upper part of the body from the chest to the fingers) is known as CT Upper Limb Angiography.",
  "A contrast is given through veins to create clear images of the upper limbs.",
  "The upper limb includes the chest, neck, arms, elbow, and wrist.",
  "Doctors recommend this scan when there are symptoms like numbness in hands, cold hands or fingers, muscle pain in arms, or other hand-related issues.",
  "The scan takes about 1–2 hours to complete."
          ],
          "keyBenefits": [
            "Comprehensive arm vascular assessment",
            "Non-invasive vascular mapping",
            "Accurate trauma evaluation",
            "Detailed surgical planning"
          ],
          "faqs": [
            {
              "question": "Who needs upper limb angiography?",
              "answer": "Patients with arm swelling, pain, trauma, suspected blood clots, vascular access problems, or thoracic outlet syndrome symptoms."
            },
            {
              "question": "What is thoracic outlet syndrome?",
              "answer": "A condition where nerves or blood vessels are compressed between the collarbone and first rib, causing arm pain and numbness."
            },
              {
    "question": "Is CT Upper Limb Angiography Safe?",
    "answer": "Yes, CT Upper Limb Angiography is generally safe. Minor reactions to contrast may occur, but serious complications are rare."
  },
  {
    "question": "How long does a CT Upper Limb Angiography take?",
    "answer": "The scan usually takes about 1–2 hours, depending on preparation and the area being imaged."
  },
  {
    "question": "What preparation is required for a CT Upper Limb Angiography?",
    "answer": "You may need to avoid eating for a few hours before the scan. Inform the medical team about any allergies or kidney issues, especially regarding contrast dye."
  }
          ]
        },
        {
          "name": "CT KUB (Kidney, Ureter & Bladder)",
          "duration": "10-15 mins",
          "preparation": "Drink water before scan, no fasting",
          "image": "https://media.istockphoto.com/id/2234260880/photo/ct-scan-of-kub-with-contrast-left-renal-small-partially-exophytic-cortical-cyst-is-seen-at.jpg?s=612x612&w=0&k=20&c=CYwPmVqXH5soCn8OoZ90bzhuIugJevMewqjxKtTjd8E=",
          "description": "Focused imaging of urinary system for stones",
          "detailedDescription": [
            "Rapid detection of urinary tract stones",
            "Evaluation of stone size and location",
            "Assessment of urinary tract obstructions",
            "Detection of calcifications and stones",
            "Emergency evaluation of renal colic",
             "An imaging technique used to examine the kidney, ureter, and bladder through computed tomography is known as CT KUB (Kidney, Ureter and Bladder).",
  "CT KUB helps to examine the urinary tract.",
  "For males, along with the KUB, the prostate gland is also examined.",
  "Doctors recommend this scan to check for urinary infections, kidney stones, or other urinary tract disorders.",
  "The urinary bladder needs to be full before going for the KUB scan.",
  "One should avoid eating for at least 4 hours before the scan.",
  "The scan takes about 15–30 minutes to complete."
          ],  
          "keyBenefits": [
            "Rapid diagnosis in emergency settings",
            "High accuracy for stone detection",
            "No contrast injection required",
            "Quick and comfortable procedure"
          ],
          "faqs": [
            {
              "question": "Is contrast used in CT KUB?",
              "answer": "No, CT KUB is typically done without contrast to better visualize stones, as contrast can sometimes obscure small stones."
            },
            {
              "question": "How small of a stone can it detect?",
              "answer": "Modern CT scanners can detect stones as small as 1-2 mm in size with high accuracy."
            },
             {
    "question": "Is CT KUB Safe?",
    "answer": "Yes, CT KUB is generally safe. Radiation exposure is low, and the procedure is painless."
  },
  {
    "question": "How long does a CT KUB take?",
    "answer": "The scan usually takes about 15–30 minutes, including preparation and imaging time."
  },
  {
    "question": "What preparation is required for a CT KUB?",
    "answer": "You should avoid eating for at least 4 hours before the scan and ensure your bladder is full. Inform the medical team about any allergies or kidney issues."
  }
          ]
        },
        {
          "name": "CT Scan Joint",
          "duration": "15-20 mins",
          "preparation": "Remove jewelry, no special preparation",
          "image": "https://media.istockphoto.com/id/499805989/photo/collection-x-ray-multiple-part-of-human.jpg?s=612x612&w=0&k=20&c=RD7kO3l3tSQQmD6YBe4xrZOiGrenJsn-IPiNxOqErC4=",
          "description": "Detailed imaging of specific joints",
          "detailedDescription": [
            "Detailed evaluation of joint anatomy",
            "Detection of fractures and dislocations",
            "Assessment of arthritis and degenerative changes",
            "Evaluation of sports injuries",
            "Pre-surgical planning for joint replacements"
          ],
          "keyBenefits": [
            "Superior bone detail compared to MRI",
            "Quick assessment of traumatic injuries",
            "Accurate fracture characterization",
            "Detailed surgical planning"
          ],
          "subServices": [
            {
              "name": "Shoulder",
              "description": "Imaging of shoulder joint for rotator cuff injuries, arthritis, and fractures"
            },
            {
              "name": "Elbow",
              "description": "Evaluation of elbow joint for fractures, arthritis, and ligament injuries"
            },
            {
              "name": "Wrist",
              "description": "Detailed imaging of wrist bones and joints for trauma and arthritis"
            },
            {
              "name": "Hip",
              "description": "Imaging of hip joint for arthritis, fractures, and avascular necrosis"
            },
            {
              "name": "Knee",
              "description": "Evaluation of knee joint for meniscal tears, arthritis, and ligament injuries"
            },
            {
              "name": "Ankle",
              "description": "Detailed imaging of ankle joint for fractures, arthritis, and tendon injuries"
            }
          ],
          "faqs": [
            {
              "question": "Which joints can be scanned?",
              "answer": "All major joints including shoulder, elbow, wrist, hip, knee, and ankle can be evaluated with CT for detailed bony anatomy assessment."
            },
            {
              "question": "Is CT better than MRI for joints?",
              "answer": "CT is superior for bone detail and fracture assessment, while MRI is better for soft tissues like ligaments and cartilage. The choice depends on the clinical question."
            }
          ]
        },
        {
          "name": "CT Scan Spine",
          "duration": "15-25 mins",
          "preparation": "No special preparation required",
          "image": "https://media.istockphoto.com/id/170615801/photo/mri-image-of-lower-back-vertebral-column.jpg?s=612x612&w=0&k=20&c=ZsCgDE1toc968k7N_jXhicdlKsTbGIYnrx9XLHgPgtU=",
          "description": "Comprehensive imaging of spinal column",
          "detailedDescription": [
            "Detailed evaluation of vertebral bones",
            "Detection of spinal fractures and injuries",
            "Assessment of disc degeneration and herniation",
            "Evaluation of spinal stenosis",
            "Pre-surgical planning for spinal surgeries"
          ],
          "keyBenefits": [
            "Superior bone anatomy visualization",
            "Accurate fracture detection",
            "Detailed spinal canal assessment",
            "Comprehensive surgical planning"
          ],
          "subServices": [
            {
              "name": "Cervical",
              "description": "Imaging of neck spine for disc herniation, stenosis, and trauma"
            },
            {
              "name": "Thoracic",
              "description": "Evaluation of mid-back spine for fractures, infections, and deformities"
            },
            {
              "name": "Lumbar",
              "description": "Detailed imaging of lower back for disc disease, stenosis, and arthritis"
            }
          ],
          "faqs": [
            {
              "question": "What spinal conditions can CT detect?",
              "answer": "Herniated discs, spinal fractures, arthritis, spinal stenosis, tumors, infections, and congenital spinal abnormalities with excellent bone detail."
            },
            {
              "question": "Can CT detect slipped discs?",
              "answer": "Yes, CT scans can clearly show herniated or slipped discs, though MRI provides better soft tissue detail for disc assessment."
            }
          ]
        },
        {
          "name": "CT Joints with 3D Reconstruction",
          "duration": "25-30 mins",
          "preparation": "Remove metal objects, no special preparation",
          "image": "https://media.istockphoto.com/id/1739109377/photo/ct-scan-of-thoracic-and-lumbar-spine-3d-rendering-showing-pedicle-screw-implant-after.jpg?s=612x612&w=0&k=20&c=NNgI9ZPKNS4xKxMEA5jvwJa8ATyVlIm3-PYcYlGCzP8=",
          "description": "Advanced 3D imaging of joints",
          "detailedDescription": [
            "Three-dimensional visualization of joint anatomy",
            "Detailed assessment of complex fractures",
            "Evaluation of congenital joint abnormalities",
            "Pre-surgical planning and simulation",
            "Custom implant design and planning",
            "3D reconstruction is the process of capturing real images and converting them into 3-dimensional views.",
  "CT Joint performed with 3D reconstruction gives detailed 3D images of the joints.",
  "Joints like shoulder, elbow, wrist, hip, knee, and ankle are examined in this scan.",
  "It helps to diagnose fractures that may not be visible on a normal X-ray.",
  "The scan takes about 15–30 minutes to perform."
          ],
          "keyBenefits": [
            "Superior spatial understanding of anatomy",
            "Enhanced surgical planning accuracy",
            "Better patient and surgeon education",
            "Customized treatment planning"
          ],
          "faqs": [
            {
              "question": "What are the benefits of 3D reconstruction?",
              "answer": "Provides better spatial understanding of complex anatomy, helps in precise surgical planning, improves diagnosis of complex fractures, and enhances communication with patients."
            },
            {
              "question": "Which joints benefit most from 3D?",
              "answer": "Complex joints like shoulder, hip, wrist, and ankle, especially in cases of complex fractures, deformities, or revision surgeries benefit most from 3D reconstruction."
            }
          ]
        },
        {
          "name": "CT Scan of Spine with 3D Reconstruction",
          "duration": "25-30 mins",
          "preparation": "No special preparation required",
          "image": "https://media.istockphoto.com/id/1741993124/photo/ct-scan-of-thoracic-and-lumbar-spine-3d-rendering.jpg?s=612x612&w=0&k=20&c=RaWlTILcisWSdgyl9tD3LIbbDguYzx_6S4fuTJ9JMxk=",
          "description": "Advanced 3D imaging of spine",
          "detailedDescription": [
            "Three-dimensional spinal column visualization",
            "Detailed assessment of spinal deformities",
            "Evaluation of complex spinal fractures",
            "Pre-surgical planning for spinal instrumentation",
            "Custom implant design and fitting",
             "3D reconstruction is the process of capturing real images and converting them into 3-dimensional views.",
  "CT Scan of Spine performed with 3D reconstruction gives detailed 3D images of the spine.",
  "It helps provide detailed, clear images of the spine to detect injuries, diseases, or disorders.",
  "The scan creates clear images of bones, muscles, and ligaments in the back using 3D technology.",
  "The scan takes about 15–30 minutes to perform."
          ],
          "keyBenefits": [
            "Comprehensive 3D spinal assessment",
            "Enhanced surgical planning for complex cases",
            "Accurate implant selection and placement",
            "Improved outcomes in deformity correction"
          ],
          "faqs": [
            {
              "question": "Who needs 3D spine CT?",
              "answer": "Patients with complex spinal deformities, scoliosis, complex fractures, or those requiring detailed surgical planning for spinal instrumentation benefit most from 3D spine CT."
            },
            {
              "question": "How does 3D help in surgery?",
              "answer": "It allows surgeons to virtually plan the surgery, choose appropriate implants, anticipate challenges, and simulate the procedure for better outcomes."
            }
          ]
        },
        {
          "name": "CT Contrast Study",
          "duration": "30-35 mins",
          "preparation": "Fasting required, kidney function tests needed",
          "image": "https://litfl.com/wp-content/uploads/2023/03/CT-abdomen-with-liver-enhancement.png",
          "description": "Enhanced CT imaging using contrast agents",
          "detailedDescription": [
            "Improved tissue differentiation and characterization",
            "Enhanced visualization of blood vessels",
            "Better detection and characterization of tumors",
            "Assessment of organ perfusion and function",
            "Improved inflammatory and infectious disease detection",
            "CT stands for Computed Tomography.",
  "CT scans are of two types: Plain CT and Contrast CT.",
  "Plain CT scan is a normal scanning method that uses imaging techniques to create images of the body part under examination.",
  "In a Contrast CT scan, an external substance is taken orally or via injection to enhance imaging.",
  "Contrast studies provide detailed and clear images of the part of the body being examined.",
  "One should avoid eating for at least 4 hours before the scan.",
  "The scan takes about 30–60 minutes to perform.",
  "Contrast CT scans are safe and painless."
          ],
          "keyBenefits": [
            "Superior pathological condition detection",
            "Enhanced tumor characterization",
            "Comprehensive vascular assessment",
            "Improved diagnostic accuracy"
          ],
          "faqs": [
            {
              "question": "Is contrast safe for everyone?",
              "answer": "Generally safe, but requires kidney function assessment. We screen for allergies, kidney problems, and other contraindications before administration."
            },
            {
              "question": "What are the side effects of contrast?",
              "answer": "Most people experience no side effects. Some may feel warm or have metallic taste. Rare allergic reactions can occur but we are prepared to manage them."
            }
          ]
        },
        {
          "name": "Full Body CT Scan",
          "duration": "45-60 mins",
          "preparation": "Fasting required, comprehensive preparation needed",
          image:  process.env.PUBLIC_URL + "/images/ct.jpg",
          "description": "Comprehensive imaging from head to toe",
          "detailedDescription": [
            "Complete head-to-toe anatomical assessment",
            "Comprehensive cancer screening and staging",
            "Whole-body trauma evaluation",
            "Systemic disease assessment",
            "Preventive health screening",
             "An imaging technique in which images are created using radiation to show internal body parts in detail is known as Full Body CT Scan.",
  "In this scan, each and every part of the body is examined in detail, from the brain to other organs.",
  "Doctors recommend Full Body CT Scan to diagnose early-stage cancer or any other abnormality or disease in the body.",
  "This scan also helps detect internal injuries to organs, problems with blood flow, and damage to bones.",
  "One should avoid eating for at least 3 hours before the scan.",
  "The scan takes about 30–60 minutes to perform."
          ],
          "keyBenefits": [
            "One-stop complete body assessment",
            "Comprehensive disease detection",
            "Early cancer and disease screening",
            "Complete trauma evaluation"
          ],
          "faqs": [
            {
              "question": "Who should get full body CT?",
              "answer": "Individuals with multiple symptoms, comprehensive health screening needs, cancer staging, trauma assessment, or systemic disease evaluation may benefit from full body CT."
            },
            {
              "question": "What is the radiation exposure?",
              "answer": "While higher than single region scans, we use advanced dose reduction techniques to minimize exposure while maintaining diagnostic quality."
            }
          ]
        }
      ]
    },

 {
  "id": "xray",
  "name": "X-RAY",
  "icon": "xray",
  "description": "Advanced digital X-ray imaging for comprehensive diagnostic evaluation",
  image:  process.env.PUBLIC_URL + "/images/xray.jpg",
  "details": "Our state-of-the-art digital X-ray facility offers high-resolution imaging with minimal radiation exposure. Equipped with latest generation digital radiography systems for faster imaging and superior diagnostic quality. Digital X-rays are the method in which, the images are immediately converted to digital data. The technology that is used produces 80% less radiation than traditional X-ray methods that use film.",
  "keyFeatures": [
    "Digital radiography for instant results",
    "Low radiation dose technology",
    "High-resolution image quality",
    "Portable imaging capabilities",
    "Expert radiologist interpretation",
    "Quick turnaround time"
  ],
  "subServices": [
    {
      "name": "Chest X-Ray",
      "duration": "10-15 mins",
      "preparation": "Remove jewelry and metal objects from chest area",
      "image": "https://media.istockphoto.com/id/488525897/photo/xray-of-a-human-torax.jpg?s=612x612&w=0&k=20&c=vV7LXh_w-NWiS76mc2YqO91beg9GG3qflcNQLFPoEA0=",
      "description": "Comprehensive imaging of chest cavity including lungs and heart",
      "detailedDescription": [
        "Detection of pneumonia and lung infections",
        "Evaluation of heart size and shape",
        "Assessment of rib fractures and chest trauma",
        "Screening for tuberculosis and lung diseases",
        "Pre-operative assessment and monitoring",
         "An imaging test that studies, diagnoses, and examines the chest area through radiation is known as Chest X-Ray.",
  "It creates images of the chest that include the heart, lungs, blood vessels, and chest bones.",
  "Chest X-Rays are done to check the working condition of the heart and lungs.",
  "Chest X-Ray helps diagnose lung disease, asthma, heart disease, cough, and other chest-related conditions.",
  "It takes about 15–30 minutes to perform the scan.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Quick diagnosis of respiratory conditions",
        "Non-invasive chest assessment",
        "Rapid emergency evaluation",
        "Effective monitoring of treatment progress"
      ],
      "faqs": [
        {
          "question": "Is a Chest X-Ray safe?",
          "answer": "Yes, chest X-rays use minimal radiation exposure equivalent to a few days of natural background radiation. Our digital systems further reduce radiation dose while maintaining image quality."
        },
        {
          "question": "How long does the procedure take?",
          "answer": "The actual imaging takes only a few seconds, but you should allow 10-15 minutes for the entire process including preparation and positioning."
        },
        {
          "question": "Do I need to hold my breath during the X-ray?",
          "answer": "Yes, you'll be asked to take a deep breath and hold it for a few seconds to ensure clear images of your lungs without motion blur."
        }
      ]
    },
    {
      "name": "Shoulder X-Ray",
      "duration": "15-20 mins",
      "preparation": "Remove shoulder jewelry and metal objects",
      "image": "https://media.istockphoto.com/id/482726023/photo/x-ray-image-of-shoulder.jpg?s=612x612&w=0&k=20&c=WvzwWZPEG2KTMt2SCaVNEiAHFPpzhi97Q2MoHD7Q01A=",
      "description": "Detailed imaging of shoulder joint and surrounding structures",
      "detailedDescription": [
        "Evaluation of shoulder dislocations and fractures",
        "Assessment of arthritis and degenerative changes",
        "Detection of rotator cuff calcifications",
        "Evaluation of shoulder impingement",
        "Post-surgical assessment and follow-up",
        "An imaging test that studies, diagnoses, and examines the bones and structures in the shoulder is known as Shoulder X-Ray.",
  "It creates images of the shoulder.",
  "It is advised if there is shoulder dislocation, pain in the shoulder, broken bones, or arthritis.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Quick assessment of shoulder injuries",
        "Clear visualization of bone structures",
        "Non-invasive joint evaluation",
        "Guidance for treatment planning"
      ],
      "faqs": [
        {
          "question": "What shoulder conditions can X-ray detect?",
          "answer": "Fractures, dislocations, arthritis, bone spurs, calcific tendinitis, and abnormalities in shoulder joint alignment."
        },
        {
          "question": "How many views are typically taken?",
          "answer": "Usually 2-3 different views are taken to fully assess the shoulder joint from different angles for comprehensive evaluation."
        }
      ]
    },
    {
      "name": "Cervical Spine X-Ray",
      "duration": "15-20 mins",
      "preparation": "Remove necklaces and earrings",
      "image": "https://media.istockphoto.com/id/1193523681/photo/human-neck-x-ray-film.jpg?s=612x612&w=0&k=20&c=U24R3W6zsR5uhZCnD8lHXK8Wzfq11GTmvNiGQFXPW8Y=",
      "description": "Imaging of neck vertebrae and spinal alignment",
      "detailedDescription": [
        "Assessment of cervical spine alignment",
        "Detection of fractures and dislocations",
        "Evaluation of degenerative disc disease",
        "Assessment of spinal curvature abnormalities",
        "Post-traumatic neck injury evaluation",
         "An imaging test that studies, diagnoses, and examines the bone structure of the cervical spine is known as a Cervical Spine X-Ray.",
  "It creates images of the neck.",
  "It helps to diagnose the reason for neck pain, spinal fractures, disk issues, tumors, and other spine or neck-related disorders.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Quick evaluation of neck injuries",
        "Clear visualization of vertebral fractures",
        "Non-invasive spinal assessment",
        "Emergency trauma assessment"
      ],
      "faqs": [
        {
          "question": "When is a cervical spine X-ray needed?",
          "answer": "After neck trauma, for persistent neck pain, evaluation of arthritis, assessment of spinal alignment, or before certain surgical procedures."
        },
        {
          "question": "Can it detect slipped discs?",
          "answer": "While X-rays show bone well, they don't directly show discs. However, they can show indirect signs of disc problems like narrowed disc spaces."
        }
      ]
    },
    {
      "name": "Knee Joint X-Ray",
      "duration": "15-20 mins",
      "preparation": "Remove knee braces, wear loose clothing",
      "image": "https://media.istockphoto.com/id/183864562/photo/x-ray.jpg?s=612x612&w=0&k=20&c=5GGM6EIYy2LvUHIrpX-1SunE5plztCdI6A4AB70DIPs=",
      "description": "Comprehensive imaging of knee joint and bones",
      "detailedDescription": [
        "Evaluation of knee fractures and dislocations",
        "Assessment of arthritis and joint space narrowing",
        "Detection of bone spurs and calcifications",
        "Evaluation of alignment and mechanical axis",
        "Pre-operative planning for knee surgery",
        "An imaging test that studies, diagnoses, and examines the knee region is known as Knee Joint X-Ray.",
  "It creates images of the parts of the bones of the knee, including the lower bone, upper bone, and surrounding soft tissues.",
  "It is advised if there is any knee injury.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Rapid assessment of knee injuries",
        "Clear visualization of joint anatomy",
        "Non-invasive knee evaluation",
        "Effective monitoring of arthritis progression"
      ],
      "faqs": [
        {
          "question": "What knee problems can X-ray show?",
          "answer": "Fractures, arthritis, joint space narrowing, bone tumors, alignment issues, and degenerative changes in the knee joint."
        },
        {
          "question": "Do I need to stand for knee X-rays?",
          "answer": "Weight-bearing views are often taken to assess joint space and alignment under load, which provides important diagnostic information."
        }
      ]
    },
    {
      "name": "Dorsal/Thoracic Spine X-Ray",
      "duration": "20-25 mins",
      "preparation": "Remove back jewelry and metal objects",
      "image": "https://media.istockphoto.com/id/514656327/photo/xray-human-spine.jpg?s=612x612&w=0&k=20&c=yg8GQioESrx2krTbzTYX-2UIGxKJqfWmtgg94Se7yZQ=",
      "description": "Imaging of middle back vertebrae and spinal column",
      "detailedDescription": [
        "Assessment of thoracic spine alignment",
        "Detection of compression fractures",
        "Evaluation of scoliosis and spinal curvature",
        "Assessment of degenerative changes",
        "Post-traumatic back injury evaluation",
         "An imaging test that studies, diagnoses, and examines the bone structure of the central part of the spine is known as a Dorsal/Thoracic Spine X-Ray.",
  "It creates images of the central spine at the back.",
  "It helps diagnose the reason for back pain, spinal fractures, issues with spinal bones, and abnormalities in the spinal structure.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Comprehensive mid-back assessment",
        "Clear visualization of vertebral fractures",
        "Non-invasive spinal evaluation",
        "Effective scoliosis monitoring"
      ],
      "faqs": [
        {
          "question": "Why is thoracic spine X-ray done?",
          "answer": "To evaluate mid-back pain, assess spinal curvature, detect fractures, evaluate arthritis, or monitor conditions like scoliosis over time."
        },
        {
          "question": "How is it different from lumbar spine X-ray?",
          "answer": "It focuses on the middle back (chest level) vertebrae, while lumbar spine X-ray evaluates the lower back vertebrae."
        }
      ]
    },
    {
      "name": "Elbow X-Ray",
      "duration": "15 mins",
      "preparation": "Remove watches and bracelets",
      "image": "https://media.istockphoto.com/id/1079683654/photo/radiography-of-right-elbow-ap-and-lateral-position-medical-concept.jpg?s=612x612&w=0&k=20&c=qiBHBHwnaxeVny-Dz_sbavnnMr8cEaLYd7C18PR3hTI=",
      "description": "Detailed imaging of elbow joint and bones",
      "detailedDescription": [
        "Evaluation of elbow fractures and dislocations",
        "Assessment of arthritis and joint degeneration",
        "Detection of loose bodies in the joint",
        "Evaluation of growth plate injuries in children",
        "Post-traumatic injury assessment",
          "An imaging test that studies, diagnoses, and examines the elbow region is known as Elbow X-Ray.",
  "It creates images of the bones of the elbow, including soft tissues, the upper bone of the elbow joint, and the lower bone of the elbow joint.",
  "It is advised when one cannot fully extend their elbow due to injury, swelling, extreme pain, numbness, or weakness in the arm.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Quick assessment of elbow injuries",
        "Clear visualization of joint alignment",
        "Non-invasive elbow evaluation",
        "Effective pediatric injury assessment"
      ],
      "faqs": [
        {
          "question": "What elbow injuries require X-ray?",
          "answer": "Any significant trauma, suspected fractures, dislocations, persistent pain, swelling, or limited movement in the elbow joint."
        },
        {
          "question": "How many views are taken?",
          "answer": "Typically 2-3 views including front, side, and sometimes oblique views to fully assess the elbow joint."
        }
      ]
    },
    {
      "name": "Lumbar Spine X-Ray",
      "duration": "20-25 mins",
      "preparation": "Remove belt and metal objects from waist",
      "image": "https://media.istockphoto.com/id/1130290622/photo/x-ray-image-of-spine.jpg?s=612x612&w=0&k=20&c=puxdpAZhHyx5SHH4xRLnfUe0jVa9_rw5p9FjRkrxFbc=",
      "description": "Imaging of lower back vertebrae and spinal structures",
      "detailedDescription": [
        "Assessment of lumbar spine alignment",
        "Detection of compression fractures",
        "Evaluation of degenerative disc disease",
        "Assessment of spondylolisthesis",
        "Post-traumatic lower back evaluation",
         "An imaging test that studies, diagnoses, and examines the lumbar region of the back, which is mainly the lower back part, is known as the Lumbar Spine X-Ray.",
  "It creates images of the lower spine at the back.",
  "It helps to diagnose the reason for chronic back pain, the effect of injuries at the back, broken bones, and other related issues.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Comprehensive lower back assessment",
        "Clear visualization of spinal abnormalities",
        "Non-invasive back pain evaluation",
        "Effective pre-operative planning"
      ],
      "faqs": [
        {
          "question": "When is lumbar spine X-ray recommended?",
          "answer": "For chronic lower back pain, after trauma, evaluation of arthritis, assessment of spinal stability, or before back surgery."
        },
        {
          "question": "Can it show nerve compression?",
          "answer": "While X-rays show bones well, they don't directly show nerves. However, they can show bone changes that might cause nerve compression."
        }
      ]
    },
    {
      "name": "Wrist Joint X-Ray",
      "duration": "15 mins",
      "preparation": "Remove watches and bracelets",
      "image": "https://media.istockphoto.com/id/1964971139/photo/human-palm-x-ray-film.jpg?s=612x612&w=0&k=20&c=UNMfFGk8zwcOQRj1-ch_7VaOV5ZD8VLvzUC-502Fyno=",
      "description": "Detailed imaging of wrist bones and joints",
      "detailedDescription": [
        "Evaluation of wrist fractures and dislocations",
        "Assessment of arthritis and joint degeneration",
        "Detection of carpal bone injuries",
        "Evaluation of growth plate injuries",
        "Post-traumatic wrist assessment",
         "An imaging test that studies, diagnoses, and examines the inside region of the wrist is known as Wrist X-Ray.",
  "It creates images of the two forearm bones of the wrist and the eight wrist bones.",
  "It is advised if there is any wrist injury, swelling, or tenderness in the wrist.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Quick assessment of wrist injuries",
        "Clear visualization of small wrist bones",
        "Non-invasive wrist evaluation",
        "Effective fracture detection"
      ],
      "faqs": [
        {
          "question": "What wrist conditions can X-ray detect?",
          "answer": "Fractures (like Colles' fracture), dislocations, arthritis, carpal instability, and developmental abnormalities in the wrist."
        },
        {
          "question": "How soon after injury should I get an X-ray?",
          "answer": "As soon as possible if you suspect a fracture, as early diagnosis and treatment lead to better healing outcomes."
        }
      ]
    },
    {
      "name": "Abdomen/KUB X-Ray",
      "duration": "15-20 mins",
      "preparation": "Empty pockets, remove metal objects",
      "image": "https://media.istockphoto.com/id/1142758706/photo/old-man-x-ray-lumbar-x-ray-image-with-pelvic-bone-in-blue-tone.jpg?s=612x612&w=0&k=20&c=EvmsJvMAqoLU3wG-yqgsm4k6F6MjP1RQKAz0hTN4f5Q=",
      "description": "Imaging of abdomen including kidneys, ureters, and bladder",
      "detailedDescription": [
        "Detection of kidney stones and calcifications",
        "Evaluation of bowel gas patterns and obstructions",
        "Assessment of abdominal masses and foreign bodies",
        "Detection of free air in abdomen",
        "Evaluation of constipation and fecal loading",
         "An imaging test that studies, diagnoses, and examines the internal tissues, organs, and bones through radiation is known as Abdominal X-Ray.",
  "It is also known as AXR (Abdominal X-Ray).",
  "It creates images of the stomach, liver, intestines, and spleen.",
  "It helps to diagnose reasons for unknown pain, nausea, vomiting, etc.",
  "When X-Ray is done to examine the bladder and kidney structures, it is known as KUB (Kidneys, Ureters, Bladder) X-Ray.",
  "It takes only about 30–60 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Quick assessment of abdominal emergencies",
        "Non-invasive abdominal evaluation",
        "Rapid detection of intestinal obstructions",
        "Effective stone and calcification detection"
      ],
      "faqs": [
        {
          "question": "What is KUB X-ray used for?",
          "answer": "Primarily for detecting kidney stones, evaluating bowel obstructions, assessing constipation, and detecting free air or fluid in the abdomen."
        },
        {
          "question": "Is special preparation needed?",
          "answer": "Usually no special preparation, though you may be asked to empty your bladder or avoid eating before the test in certain situations."
        }
      ]
    },
    {
      "name": "Hip Joint X-Ray",
      "duration": "20 mins",
      "preparation": "Empty pockets, wear loose clothing",
      "image": "https://media.istockphoto.com/id/491297470/photo/human-hip.jpg?s=612x612&w=0&k=20&c=dmT_-IMgtK8ckDV8CCaSxQmeSJ_93Y0s7Esf8O3L890=",
      "description": "Comprehensive imaging of hip joint and pelvis",
      "detailedDescription": [
        "Evaluation of hip fractures and dislocations",
        "Assessment of arthritis and joint degeneration",
        "Detection of avascular necrosis",
        "Evaluation of developmental dysplasia",
        "Pre-operative planning for hip replacement",
          "An imaging test that studies, diagnoses, and examines the hip region is known as Hip Joint X-Ray.",
  "It creates images of the inside area of the hip.",
  "It is advised if there are broken bones in the hip or a dislocated joint, or if a person is unable to stand due to falling on the hip or knee.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Comprehensive hip joint assessment",
        "Clear visualization of pelvic bones",
        "Non-invasive hip evaluation",
        "Effective arthritis monitoring"
      ],
      "faqs": [
        {
          "question": "What hip conditions require X-ray?",
          "answer": "Hip pain, suspected fractures, arthritis evaluation, avascular necrosis, developmental abnormalities, or pre-surgical planning."
        },
        {
          "question": "Can X-ray show hip arthritis?",
          "answer": "Yes, X-rays clearly show joint space narrowing, bone spurs, and other changes characteristic of hip arthritis."
        }
      ]
    },
    {
      "name": "Skull X-Ray",
      "duration": "20-25 mins",
      "preparation": "Remove all head jewelry and metal objects",
      "image": "https://media.istockphoto.com/id/1193523681/photo/human-neck-x-ray-film.jpg?s=612x612&w=0&k=20&c=U24R3W6zsR5uhZCnD8lHXK8Wzfq11GTmvNiGQFXPW8Y=",
      "description": "Imaging of skull bones and cranial structures",
      "detailedDescription": [
        "Evaluation of skull fractures",
        "Assessment of sinus infections and abnormalities",
        "Detection of foreign bodies",
        "Evaluation of skull shape and development",
        "Post-traumatic head injury assessment",
        "An imaging test that studies, diagnoses, and examines the bones surrounding the brain along with facial bones, nose, and sinuses.",
  "It creates detailed images of the internal structures of the skull.",
  "Helps diagnose skull fractures, infections, tumors, and other skull-related disorders.",
  "The procedure typically takes about 10–20 minutes.",
  "It is a safe procedure and does not harm the human body."
      ],
      "keyBenefits": [
        "Quick assessment of head injuries",
        "Clear visualization of skull fractures",
        "Non-invasive cranial evaluation",
        "Effective sinus disease assessment"
      ],
      "faqs": [
        {
          "question": "When is skull X-ray necessary?",
          "answer": "After head trauma with suspected fractures, evaluation of sinus problems, assessment of skull abnormalities, or detection of foreign bodies."
        },
        {
          "question": "Is CT scan better for head injuries?",
          "answer": "CT scan provides more detailed information for complex head injuries, but X-ray is often sufficient for simple fractures and initial assessment."
        }
      ]
    },
    {
      "name": "Hand X-Ray",
      "duration": "15 mins",
      "preparation": "Remove rings and hand jewelry",
      "image": "https://media.istockphoto.com/id/183772684/photo/x-ray-of-a-left-hand-and-right-hand.jpg?s=612x612&w=0&k=20&c=_lfq0jMaZziZxIWgeTef94aigTlgZXB9adj-gktABYs=",
      "description": "Detailed imaging of hand bones and joints",
      "detailedDescription": [
        "Evaluation of hand fractures and dislocations",
        "Assessment of arthritis and joint changes",
        "Detection of foreign bodies",
        "Evaluation of bone infections",
        "Assessment of developmental abnormalities",
         "An imaging test that studies, diagnoses, and examines the hand region is known as Hand X-Ray.",
  "It creates images of the internal structures of the wrist and fingers.",
  "It is advised to detect tumors, fractures, and bone injuries in the wrist area.",
  "It also helps identify abnormal bone growth in the hands.",
  "The procedure typically takes about 15–20 minutes.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Detailed hand anatomy visualization",
        "Quick assessment of hand injuries",
        "Non-invasive hand evaluation",
        "Effective arthritis monitoring"
      ],
      "faqs": [
        {
          "question": "What hand conditions can X-ray detect?",
          "answer": "Fractures, dislocations, arthritis, bone infections, tumors, foreign bodies, and developmental abnormalities in the hand bones."
        },
        {
          "question": "How many views are typically taken?",
          "answer": "Usually 3 views - front, side, and oblique - to fully assess all the small bones and joints of the hand."
        }
      ]
    },
    {
      "name": "PNS X-Ray",
      "duration": "15 mins",
      "preparation": "Remove nose rings and facial jewelry",
      "image": "https://media.istockphoto.com/id/1281534756/photo/human-brain-neural-network-cerebral-cortex.jpg?s=612x612&w=0&k=20&c=RU_cEJ3BOGLdJfTsGqKjjNgUcMx4nUuMSigwWHIVizc=",
      "description": "Imaging of paranasal sinuses for sinus evaluation",
      "detailedDescription": [
        "Evaluation of sinus infections and inflammation",
        "Assessment of sinus drainage and aeration",
        "Detection of sinus polyps and masses",
        "Evaluation of sinus trauma and fractures",
        "Pre-operative sinus surgery planning",
         "An imaging test that studies, diagnoses, and examines the paranasal sinuses (PNS) with the surrounding soft tissues is known as PNS X-Ray.",
  "It creates images of the Paranasal Sinuses.",
  "It is also known as Sinus X-Ray.",
  "It helps to diagnose sinus infections, tumors in the nose, or any other nose-related disorders.",
  "It takes about 15–30 minutes to perform the procedure.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Quick assessment of sinus conditions",
        "Clear visualization of sinus anatomy",
        "Non-invasive sinus evaluation",
        "Effective infection monitoring"
      ],
      "faqs": [
        {
          "question": "What is PNS X-ray used for?",
          "answer": "To diagnose sinusitis, evaluate sinus infections, assess sinus drainage problems, detect polyps, and evaluate sinus trauma."
        },
        {
          "question": "Can it detect sinus cancer?",
          "answer": "While it can show masses or bone destruction that might suggest cancer, CT or MRI is usually needed for definitive evaluation of sinus tumors."
        }
      ]
    },
    {
      "name": "Foot X-Ray",
      "duration": "15 mins",
      "preparation": "Remove shoes and socks",
      "image": "https://media.istockphoto.com/id/93019150/photo/a-roentgenogram-x-ray-of-the-feet.jpg?s=612x612&w=0&k=20&c=MKn8hslVU9m5UNytL8UsXAgEh_9tHpS4aS0t169mbjQ=",
      "description": "Detailed imaging of foot bones and architecture",
      "detailedDescription": [
        "Evaluation of foot fractures and dislocations",
        "Assessment of arthritis and joint changes",
        "Detection of foreign bodies",
        "Evaluation of foot deformities",
        "Assessment of bone infections",
        "An imaging test that studies, diagnoses, and examines the foot is known as Foot X-Ray.",
  "It creates images of the internal structures of the foot.",
  "It is advised to detect the reason behind foot pain, broken bones, swelling, or tenderness in the foot.",
  "It takes about 15–20 minutes to perform the procedure.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Detailed foot anatomy visualization",
        "Quick assessment of foot injuries",
        "Non-invasive foot evaluation",
        "Effective deformity assessment"
      ],
      "faqs": [
        {
          "question": "What foot problems require X-ray?",
          "answer": "Fractures, arthritis, deformities like bunions or flat feet, foreign bodies, infections, or evaluation of persistent foot pain."
        },
        {
          "question": "Are weight-bearing views important?",
          "answer": "Yes, weight-bearing views show how the foot bones align under load, which is crucial for evaluating many foot conditions and deformities."
        }
      ]
    },
    {
      "name": "Mastoid X-Ray",
      "duration": "20 mins",
      "preparation": "Remove earrings and neck jewelry",
      "image": "https://media.istockphoto.com/id/907775962/photo/skull-fractures-x-ray-image-anteroposterior-view.jpg?s=612x612&w=0&k=20&c=hKqXXJQmyAOIHgM-mdMNsq-Ad-kG6jOjSvn2hUUIDdU=",
      "description": "Imaging of mastoid bones behind the ears",
      "detailedDescription": [
        "Evaluation of mastoid infections and inflammation",
        "Assessment of mastoid air cell development",
        "Detection of cholesteatoma and bone erosion",
        "Evaluation of temporal bone fractures",
        "Assessment of chronic ear disease complications",
        "An imaging test that studies, diagnoses, and examines the mastoid bone, located behind the ear, is known as Mastoid X-Ray.",
  "It creates images of the internal part of the back of the ear.",
  "It is advised by doctors when symptoms like ear discharge, redness behind the ear, headache, or hearing loss are experienced.",
  "Mastoiditis is caused due to infection in the mastoid bone.",
  "It takes about 15–30 minutes to perform the procedure.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Detailed mastoid bone visualization",
        "Non-invasive ear region assessment",
        "Effective infection evaluation",
        "Clear bone anatomy demonstration"
      ],
      "faqs": [
        {
          "question": "Why is mastoid X-ray done?",
          "answer": "To evaluate chronic ear infections, mastoiditis, suspected cholesteatoma, temporal bone fractures, or complications of ear diseases."
        },
        {
          "question": "Is this test commonly done today?",
          "answer": "While CT scan provides more detailed information, mastoid X-ray is still valuable for initial assessment and in resource-limited settings."
        }
      ]
    },
    {
      "name": "IVP (Intravenous Pyelogram)",
      "duration": "45-60 mins",
      "preparation": "Fasting and bowel preparation required",
      "image": "https://media.istockphoto.com/id/1182580596/photo/intravenous-pyelogram-or-i-v-p-is-an-x-ray-exam-of-urinary-tract-after-injection-contrast.jpg?s=612x612&w=0&k=20&c=xP8d2zpnDYWdTxnAhl01FJIM3t6Qz8KbNwsOlHLmcik=",
      "description": "Contrast-enhanced imaging of urinary system",
      "detailedDescription": [
        "Comprehensive evaluation of kidney function",
        "Assessment of urinary tract anatomy",
        "Detection of kidney stones and obstructions",
        "Evaluation of urinary tract tumors",
        "Assessment of congenital abnormalities",
          "An imaging test that studies, diagnoses, and examines the IVP, which stands for Intravenous Pyelogram, is known as IVP X-Ray.",
  "It creates images of the urinary tract, which is made up of the kidneys and two organs located below the rib cage.",
  "It is advised to examine the kidney, ureter, and bladder, and to detect blood in the urine or any pain in the lower back or side.",
  "It takes only about 30 minutes to perform the procedure.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Combined anatomical and functional assessment",
        "Comprehensive urinary system evaluation",
        "Detailed obstruction localization",
        "Effective tumor and stone detection"
      ],
      "faqs": [
        {
          "question": "What is the difference between IVP and CT urography?",
          "answer": "IVP uses X-rays with contrast to show both structure and function, while CT urography provides more detailed 3D images but with higher radiation dose."
        },
        {
          "question": "Is contrast injection safe?",
          "answer": "Generally safe, but we screen for allergies and kidney function. Modern contrast agents have significantly reduced risk of reactions."
        }
      ]
    },
    {
      "name": "Ankle Joint X-Ray",
      "duration": "15 mins",
      "preparation": "Remove shoes, socks, and ankle jewelry",
      "image": "https://media.istockphoto.com/id/175420238/photo/x-ray-image-of-the-foot.jpg?s=612x612&w=0&k=20&c=ZD2iJTQ68XpEkWCJVY4S01v_C-audmPVSoagsU7vYyQ=",
      "description": "Detailed imaging of ankle joint and surrounding bones",
      "detailedDescription": [
        "Evaluation of ankle fractures and dislocations",
        "Assessment of ligament injuries and instability",
        "Detection of arthritis and joint degeneration",
        "Evaluation of growth plate injuries",
        "Post-traumatic ankle assessment",
        "An imaging test that studies, diagnoses, and examines the ankle joint of the foot is known as Ankle Joint X-Ray.",
  "It creates images of the joint area which connects the leg and the foot.",
  "It is advised by doctors when there are symptoms like ankle sprain, inability to bear weight, fracture of the ankle, tenderness, or swelling around the ankle.",
  "It takes about 15–30 minutes to perform the procedure.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Quick assessment of ankle injuries",
        "Clear visualization of joint alignment",
        "Non-invasive ankle evaluation",
        "Effective fracture classification"
      ],
      "faqs": [
        {
          "question": "What ankle injuries require X-ray?",
          "answer": "Any significant ankle trauma, suspected fractures, severe sprains, persistent pain, swelling, or inability to bear weight on the ankle."
        },
        {
          "question": "How many views are typically taken?",
          "answer": "Usually 3 views - front, side, and a special view called mortise view to fully assess the ankle joint and surrounding bones."
        }
      ]
    },
    {
      "name": "HSG (Hysterosalpingography)",
      "duration": "30-45 mins",
      "preparation": "Schedule after menstrual period, no intercourse before procedure",
      "image": "https://media.istockphoto.com/id/1386377741/photo/x-ray-image-of-normal-hysterosalpingography.jpg?s=612x612&w=0&k=20&c=gpsLtUVcbYYkGKak-_kuRfLZg68gQihNNDjYAsAxkYE=",
      "description": "Contrast-enhanced imaging of uterus and fallopian tubes",
      "detailedDescription": [
        "Evaluation of fallopian tube patency",
        "Assessment of uterine shape and cavity",
        "Detection of uterine abnormalities and adhesions",
        "Evaluation of tubal blockages",
        "Infertility workup and assessment",
         "An imaging test that studies, diagnoses, and examines the internal shape of the uterus and shows if the fallopian tubes are blocked is known as Hysterosalpingography, or HSG.",
  "In this procedure, a thin tube is threaded through the vagina and cervix.",
  "It takes about 10–20 minutes to perform the procedure.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Direct visualization of reproductive anatomy",
        "Assessment of tubal function",
        "Detection of structural abnormalities",
        "Guidance for fertility treatment"
      ],
      "faqs": [
        {
          "question": "Is HSG painful?",
          "answer": "Some women experience cramping similar to menstrual cramps during the procedure, but it's usually brief and manageable with over-the-counter pain relief."
        },
        {
          "question": "When in the cycle should HSG be done?",
          "answer": "Typically between day 7 and 10 of the menstrual cycle, after bleeding has stopped but before ovulation occurs."
        }
      ]
    },
    {
      "name": "RGU & MCU",
      "duration": "30-45 mins",
      "preparation": "Bladder should be full for MCU part",
      "image": "https://media.istockphoto.com/id/1975243021/photo/x-ray-rgu-and-mcu.jpg?s=612x612&w=0&k=20&c=bmeG1QuMFSLJTSnMKaJbzHB69_Bk0aK8eHAfbBnPVcI=",
      "description": "Combined imaging of urethra and bladder function",
      "detailedDescription": [
        "Evaluation of urethral anatomy and strictures",
        "Assessment of bladder function and emptying",
        "Detection of vesicoureteral reflux",
        "Evaluation of urinary incontinence",
        "Assessment of congenital urinary abnormalities",
          "An imaging test that studies, diagnoses, and examines the urethra for detecting structural disorders or abnormalities not visible in a normal X-Ray is known as Retrograde Urethrogram (RGU).",
  "The urethra is the narrow muscular tube that drains urine from the bladder.",
   "An imaging test that studies, diagnoses, and examines the urethra and bladder while passing urine using X-ray dye is known as Micturating Cysto-Urethrogram (MCU).",
  "This test helps to understand if the urine flows normally through the urethra or if it refluxes back to the kidneys.",
  "It takes about 10–20 minutes to perform the procedure.",
  "It is a safe technique that does not harm the human body.",

      ],
      "keyBenefits": [
        "Comprehensive urinary function assessment",
        "Dynamic evaluation of voiding process",
        "Detection of reflux and strictures",
        "Guidance for urological treatment"
      ],
      "faqs": [
        {
          "question": "What is the difference between RGU and MCU?",
          "answer": "RGU (Retrograde Urethrogram) evaluates the urethra, while MCU (Micturating Cystourethrogram) assesses bladder function and detects reflux during urination."
        },
        {
          "question": "Is this procedure uncomfortable?",
          "answer": "Some discomfort may occur during catheter insertion and contrast injection, but the procedure is generally well-tolerated with proper technique and patient preparation."
        }
      ]
    }
  ]
},

 {
  "id": "sonography",
  "name": "SONOGRAPHY",
  "icon": "ultrasound",
  "description": "Advanced ultrasound imaging for comprehensive diagnostic evaluation using high-frequency sound waves",
  image:  process.env.PUBLIC_URL + "/images/usg.jpg",
  "details": "Our state-of-the-art ultrasound facility offers high-resolution imaging with advanced Doppler capabilities. Equipped with latest generation ultrasound systems with 2D, 3D, 4D, and specialized imaging technologies for accurate diagnosis. A diagnostic medical procedure that uses High-Frequency Sound Waves (also known as ultrasound), to produce dynamic visual images of organs, tissues or blood flow inside The body is known as Sonography. The above type Of procedure is usually referred to as a Sonogram Or Ultrasound Exam.",
  "keyFeatures": [
    "High-resolution real-time imaging",
    "Color and power Doppler capabilities",
    "3D/4D volumetric imaging",
    "No radiation exposure - completely safe",
    "Portable imaging for bedside evaluation",
    "Expert sonologist interpretation"
  ],
  "subServices": [
    {
      "name": "Abdomen Ultrasound",
      "duration": "20-30 mins",
      "preparation": "6-8 hours fasting required",
      "image": "https://media.istockphoto.com/id/502384526/photo/ultrasound-exam.jpg?s=612x612&w=0&k=20&c=5_kxOBOd_aJYaY9HVjfHseAao2OimtgL6de-_NqQ2XA=",
      "description": "Comprehensive imaging of abdominal organs including liver, gallbladder, pancreas, and spleen",
      "detailedDescription": [
        "Detailed evaluation of liver size, texture, and focal lesions",
        "Gallbladder assessment for stones, polyps, and wall thickening",
        "Pancreas evaluation for inflammation and masses",
        "Spleen size and texture assessment",
        "Detection of abdominal lymph nodes and free fluid",
        "An imaging technique used to see the internal part of the abdomen through ultrasound is known as USG Abdomen.",
  "It checks the liver, pancreas, kidneys, and gallbladder area of the abdomen for any abnormalities.",
  "Doctors advise this test to diagnose the cause of stomach pain.",
  "It helps detect tumors in the abdomen, kidney stones, or any other liver-related disease.",
  "It is a simple and painless scan.",
  "The procedure takes about 20–30 minutes to perform."
      ],
      "keyBenefits": [
        "Non-invasive abdominal organ assessment",
        "No radiation exposure",
        "Real-time evaluation of organ function",
        "Quick diagnosis of abdominal conditions"
      ],
      "faqs": [
        {
          "question": "Why is fasting required for abdominal ultrasound?",
          "answer": "Fasting ensures the gallbladder is properly distended and reduces bowel gas interference, providing clearer images of abdominal organs."
        },
        {
          "question": "Can I drink water before the test?",
          "answer": "Small sips of water are usually acceptable, but you should avoid large quantities. Follow the specific instructions given during booking."
        }
      ]
    },
    {
      "name": "Pelvis Ultrasound",
      "duration": "20-30 mins",
      "preparation": "Full bladder required",
      "image": "https://media.istockphoto.com/id/461179806/video/ultrasound-of-fibroid-interuterine-measurement.jpg?s=640x640&k=20&c=hByT1IpwdIii05TvEG3DQal04EPOKAMQ0emQipzCrwQ=",
      "description": "Imaging of pelvic organs including uterus, ovaries, and bladder",
      "detailedDescription": [
        "Evaluation of uterine size, shape, and endometrial thickness",
        "Ovarian assessment for cysts, follicles, and masses",
        "Detection of pelvic inflammatory disease",
        "Evaluation of bladder wall and capacity",
        "Assessment of pelvic masses and fibroids",
        "The female reproductive system is very important, and its health is crucial for reproductive capacity.",
  "It is necessary to study the female reproductive system periodically.",
  "One common test referred by gynecologists is USG Abdomen Pelvis.",
  "The pelvis comprises female pelvic organs and structures like the uterus, ovaries, fallopian tubes, vagina, and cervix.",
  "USG Abdomen Pelvis helps doctors and gynecologists to study, diagnose, and treat the pelvic and abdominal organs of females.",
  "A radiologist or sonographer performs the USG Abdomen Pelvis. A small amount of gel is applied to the abdomen to assist the ultrasound device in creating images.",
  "It is a simple test that takes about 20–40 minutes to perform."
      ],
      "keyBenefits": [
        "Detailed pelvic organ visualization",
        "No radiation exposure",
        "Real-time assessment of reproductive organs",
        "Guidance for gynecological treatments"
      ],
      "faqs": [
        {
          "question": "Why do I need a full bladder for pelvic ultrasound?",
          "answer": "A full bladder acts as an acoustic window, pushing bowel loops away and providing better visualization of the pelvic organs."
        },
        {
          "question": "When is the best time for pelvic ultrasound?",
          "answer": "For routine evaluation, it's often done after menstrual period. Your doctor will advise the optimal timing based on your specific needs."
        }
      ]
    },
    {
      "name": "Transvaginal Scan (TVS)",
      "duration": "15-20 mins",
      "preparation": "Empty bladder recommended",
      "image": "https://media.istockphoto.com/id/1363594438/photo/ultrasound-image-of-myoma.jpg?s=612x612&w=0&k=20&c=YbAuxlfArYvmgjWFM3VAmLb_H8uongx8MRzKRhs4gLU=",
      "description": "Internal ultrasound for detailed evaluation of pelvic structures",
      "detailedDescription": [
        "High-resolution imaging of uterus and ovaries",
        "Early pregnancy detection and dating",
        "Evaluation of ectopic pregnancy",
        "Assessment of ovarian reserve and follicle monitoring",
        "Detailed endometrial cavity evaluation",
         "Ultrasound sonography that examines the vaginal organ within the pelvic area is known as Transvaginal USG.",
  "It helps to examine and study the fallopian tubes, ovaries, and uterus properly.",
  "It is generally done in females when physical abnormalities like tumors, cysts, or fibroids are noticed.",
  "It is also conducted for pregnant women in the first trimester.",
  "The procedure takes about 45–60 minutes to perform."
      ],
      "keyBenefits": [
        "Superior image quality compared to abdominal approach",
        "Early detection of pregnancy complications",
        "Accurate assessment of small pelvic structures",
        "Better visualization in obese patients"
      ],
      "faqs": [
        {
          "question": "Is transvaginal ultrasound painful?",
          "answer": "Most women experience minimal discomfort similar to a pelvic exam. The procedure is brief and our technicians are trained to ensure your comfort."
        },
        {
          "question": "Can it be done during pregnancy?",
          "answer": "Yes, it's safe during pregnancy and often used in early pregnancy for better visualization of the gestational sac and embryo."
        }
      ]
    },
    {
      "name": "Anomaly Scan (2D/4D)",
      "duration": "45-60 mins",
      "preparation": "Moderately full bladder recommended",
      "image": "https://media.istockphoto.com/id/163725602/photo/leukodystrophy-illness-and-developmental-anomaly.jpg?s=612x612&w=0&k=20&c=mZslJlJV3paVN4nUXk-ZAJObeVvMn0Fot9Fo3t78ACI=",
      "description": "Comprehensive fetal anatomical survey typically done at 18-22 weeks",
      "detailedDescription": [
        "Detailed evaluation of fetal brain and spine",
        "Assessment of heart chambers and great vessels",
        "Examination of face, lips, and palate",
        "Evaluation of abdominal organs and limbs",
        "Measurement of amniotic fluid and placental location",
        "Anomaly Scan refers to the ultrasound scan of the anatomic structure of the fetus, usually done in the 20th week of pregnancy.",
  "It is considered Level 2 of the ultrasound scan during pregnancy.",
  "It provides a detailed study of the fetus, pelvic organs, and placenta to assess whether the fetus is developing normally.",
  "The scan examines every part of the fetus, providing information on growth and development.",
  "Major parts checked include the brain, heart, spine, stomach, face, kidneys, liver, and limbs.",
  "The scan aims to detect any rare conditions related to the brain, heart, spine, stomach, face, kidneys, liver, and limbs.",
  "It helps doctors and the pregnant woman make informed decisions if any abnormalities are detected.",
  "No fasting is required before the scan, and a full bladder is not necessary.",
  "The procedure takes about 45–60 minutes.",
  "The scan is not painful, though slight pressure may be felt during scanning.",
  "Anomaly Scan is safe and does not cause harm to the pregnant woman or the fetus."
      ],
      "keyBenefits": [
        "Comprehensive fetal anatomy assessment",
        "Early detection of structural abnormalities",
        "4D imaging for better parental bonding",
        "Peace of mind during pregnancy"
      ],
      "faqs": [
        {
          "question": "What is the difference between 2D and 4D anomaly scan?",
          "answer": "2D provides detailed cross-sectional images for medical evaluation, while 4D adds real-time motion and surface rendering for better visualization and parental bonding."
        },
        {
          "question": "Can anomaly scan detect all birth defects?",
          "answer": "While it detects most major structural abnormalities, no ultrasound can guarantee detection of all birth defects. Detection rates vary depending on the condition."
        }
      ]
    },
    {
      "name": "NT Scan (2D/4D)",
      "duration": "30-45 mins",
      "preparation": "Moderately full bladder recommended",
      "image": "https://media.istockphoto.com/id/1127759868/photo/ultrasound-of-baby-in-mothers-at-hospital.jpg?s=612x612&w=0&k=20&c=H4HVWnR8ISDVeZ-72LJmMMMUaFZ2DzySzNKrI-28oeE=",
      "description": "First trimester screening for chromosomal abnormalities",
      "detailedDescription": [
        "Measurement of nuchal translucency thickness",
        "Assessment of nasal bone presence",
        "Evaluation of fetal blood flow patterns",
        "Early anatomy survey",
        "Combined with maternal blood markers for risk assessment",
        "NT Scan refers to Nuchal Translucency, a scan usually done in the first trimester of pregnancy, between 11–14 weeks.",
  "It is considered Level 1 of the ultrasound scan during pregnancy.",
  "This test helps detect and measure the nuchal translucency (NT) tissue at the back of the baby’s neck.",
  "It allows early detection of Down syndrome or other abnormalities in the fetus.",
  "The scan is performed externally by qualified and experienced radiologists.",
  "The procedure takes about 30–40 minutes.",
  "NT Scan is safe and does not cause harm to the pregnant woman or the fetus."
      ],
      "keyBenefits": [
        "Early screening for Down syndrome",
        "Non-invasive risk assessment",
        "Early detection of major abnormalities",
        "Accurate pregnancy dating"
      ],
      "faqs": [
        {
          "question": "When should NT scan be done?",
          "answer": "Optimally between 11 weeks 2 days and 13 weeks 6 days of pregnancy, when the CRL measures 45-84 mm."
        },
        {
          "question": "Is NT scan diagnostic for Down syndrome?",
          "answer": "No, it's a screening test that provides risk assessment. Diagnostic testing like CVS or amniocentesis would be needed for confirmation."
        }
      ]
    },
    {
      "name": "Musculoskeletal Ultrasound",
      "duration": "20-40 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1417852196/photo/doctor-conducting-ultrasound-examination-of-knee-joint-in-child-closeup.jpg?s=612x612&w=0&k=20&c=UxDnCDOeoOews4FkNz13OV0m8Uz4bcXLIAkHFt7-d8A=",
      "description": "Dynamic imaging of muscles, tendons, ligaments, and joints",
      "detailedDescription": [
        "Evaluation of tendon tears and tendinitis",
        "Assessment of muscle injuries and hematomas",
        "Detection of joint effusions and synovitis",
        "Evaluation of ligament injuries",
        "Guidance for therapeutic injections",
        "An imaging ultrasound technique that examines the joints and muscle nerves in the human body is known as Musculoskeletal USG.",
  "This technique creates images of the body’s internal parts.",
  "Doctors recommend this test when there is pain in the joints, nerves, or muscles.",
  "The procedure takes about 45 minutes to perform.",
  "This technique is safe and painless."
      ],
      "keyBenefits": [
        "Real-time dynamic assessment",
        "Comparison with opposite side",
        "No radiation exposure",
        "Excellent for soft tissue evaluation"
      ],
      "faqs": [
        {
          "question": "Which conditions can musculoskeletal ultrasound detect?",
          "answer": "Rotator cuff tears, tennis elbow, carpal tunnel syndrome, Achilles tendonitis, muscle tears, bursitis, and many other soft tissue conditions."
        },
        {
          "question": "Is it better than MRI for musculoskeletal problems?",
          "answer": "It's excellent for superficial structures and dynamic assessment, while MRI is better for deep structures and bone marrow evaluation. They are often complementary."
        }
      ]
    },
    {
      "name": "Ovulation Study (Follicular)",
      "duration": "15-20 mins per session",
      "preparation": "Empty bladder for transvaginal approach",
      "image": "https://media.istockphoto.com/id/178438513/photo/ultrasound-medical-device-for-diagnostics.jpg?s=612x612&w=0&k=20&c=PuLBGX_s6WEQ-Zv6Cx1YiC9WlSw6K7wUL3pPQUF_U1Q=",
      "description": "Serial monitoring of ovarian follicle development",
      "detailedDescription": [
        "Tracking follicle growth and development",
        "Assessment of endometrial thickness and pattern",
        "Detection of ovulation",
        "Evaluation of corpus luteum formation",
        "Timing for fertility treatments",
         "An internal and external ultrasound is done to examine and study the uterine lining, uterus, and ovaries of females, known as Ovulation Study or Follicular Study.",
  "It helps track the ovulation cycle to determine when ovulation or egg release occurs.",
  "Doctors advise performing the Ovulation Study between day 11 and day 19 of the menstrual cycle, as cycles vary between females.",
  "The scan is typically done on every alternate day during the ovulation period.",
  "The procedure takes about 10–20 minutes to perform.",
  "It is a safe and painless study conducted by a radiologist."
      ],
      "keyBenefits": [
        "Accurate ovulation prediction",
        "Monitoring response to fertility drugs",
        "Optimal timing for intercourse or IUI",
        "Assessment of ovarian function"
      ],
      "faqs": [
        {
          "question": "How many sessions are needed for ovulation study?",
          "answer": "Typically 3-5 sessions starting from day 9-10 of cycle, every 1-2 days until ovulation is confirmed."
        },
        {
          "question": "Can it detect ovulation problems?",
          "answer": "Yes, it can identify anovulation, luteinized unruptured follicle syndrome, and other ovulation disorders."
        }
      ]
    },
    {
      "name": "Ocular / B Scan of Eye",
      "duration": "20-30 mins",
      "preparation": "Remove eye makeup, no contact lenses",
      "image": "https://media.istockphoto.com/id/2185668382/photo/b-scan-ultrasonography-high-intensity-membranous-echogenic-shadow-with-medium-intensity.jpg?s=612x612&w=0&k=20&c=NLm35wXMTdhgZR2nhGAT-rKZwqmyzV_wgxNGEw1X_5Y=",
      "description": "Ultrasound imaging of the eye and orbit",
      "detailedDescription": [
        "Evaluation of retinal detachment",
        "Assessment of vitreous hemorrhage",
        "Detection of intraocular tumors",
        "Measurement of eye dimensions",
        "Evaluation when media opacities prevent direct visualization",
        "A technique used to scan the brightness of the eye is known as B Scan.",
  "B Scan stands for Brightness Scan.",
  "Doctors advise this scan to detect cataracts or other eye-related disorders.",
  "The procedure takes about 15–20 minutes to perform.",
  "It is a simple and painless scan."
      ],
      "keyBenefits": [
        "Evaluation when direct visualization is not possible",
        "No radiation exposure",
        "Detailed assessment of posterior segment",
        "Pre-operative planning for eye surgeries"
      ],
      "faqs": [
        {
          "question": "When is ocular ultrasound needed?",
          "answer": "When cataracts, corneal opacities, or vitreous hemorrhage prevent direct examination of the retina and posterior eye structures."
        },
        {
          "question": "Is it uncomfortable?",
          "answer": "The procedure is painless. Gel is applied on closed eyelids and the probe gently moves over them without touching the eye directly."
        }
      ]
    },
    {
      "name": "2D Echo",
      "duration": "30-45 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1223615268/video/image-on-the-monitor-of-a-medical-ultrasound-machine.jpg?s=640x640&k=20&c=P3fGxr08ppKsRWkndlpWzdWVxXc0qR_jlzmRdU1TQzI=",
      "description": "Comprehensive ultrasound evaluation of heart structure and function",
      "detailedDescription": [
        "Assessment of heart chamber sizes and function",
        "Evaluation of heart valve structure and motion",
        "Measurement of heart wall thickness",
        "Detection of congenital heart defects",
        "Evaluation of pericardial effusion",
         "Echo refers to Echocardiography.",
  "An imaging procedure that examines the function of the different parts of the heart is known as 2D Echo.",
  "Through 2D Echo, doctors can assess blockages, damage, blood flow rate, and other heart-related issues.",
  "When a heart disorder is suspected, doctors advise 2D Echo to check for abnormalities.",
  "The procedure takes about 45–60 minutes to perform.",
  "It is a safe technique that does not harm the human body, as no radiation is used."
      ],
      "keyBenefits": [
        "Non-invasive cardiac assessment",
        "Real-time evaluation of heart function",
        "No radiation exposure",
        "Comprehensive hemodynamic information"
      ],
      "faqs": [
        {
          "question": "What conditions can 2D Echo detect?",
          "answer": "Heart valve problems, heart muscle diseases, congenital heart defects, heart failure, pericardial effusion, and cardiac tumors."
        },
        {
          "question": "Is there any risk with 2D Echo?",
          "answer": "No, it's completely safe and non-invasive with no known risks or side effects."
        }
      ]
    },
    {
      "name": "GLS 2D Echo",
      "duration": "45-60 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1175254260/photo/screen-of-echocardiography-machine.jpg?s=612x612&w=0&k=20&c=sBrhAd59Q8gjX4h8OItG46v9yfu0LRz-kRJKRyJGp3E=",
      "description": "Advanced echocardiography with Global Longitudinal Strain analysis",
      "detailedDescription": [
        "Quantitative assessment of myocardial deformation",
        "Early detection of subclinical heart dysfunction",
        "Monitoring of chemotherapy cardiotoxicity",
        "Assessment of heart function in athletes",
        "Evaluation of subtle myocardial diseases",
        "Global Longitudinal Strain (GLS) is an advanced method to fine-tune your 2D Echo.",
  "Heart pumping, i.e., left ventricular ejection fraction (LVEF), is an important predictor of long-term outcomes in various heart problems.",
  "Recent advances have shown that LVEF is affected later in the course of disease, whereas GLS is more sensitive and can detect early changes in heart muscle.",
  "Even if the ejection fraction is normal, abnormal GLS signifies early or advanced disease.",
  "GLS is done using advanced echocardiography that images the heart muscle more precisely, quantifying the shortening of each segment of the left ventricular muscle.",
  "Integrating all segments, a bull’s eye image is created, giving both local and global longitudinal strain information.",
  "GLS is useful in conditions such as:",
  "Heart failure with preserved ejection fraction (common in elderly with diabetes and hypertension).",
  "Post-Covid myocarditis (inflammation and damage to heart muscle cells).",
  "Ischemic heart disease in stable individuals.",
  "Left ventricular hypertrophy (athlete’s heart, hypertension, hypertrophic cardiomyopathy, amyloidosis).",
  "Dilated cardiomyopathy.",
  "Unstable angina for early diagnosis.",
  "Valvular heart diseases (severe aortic stenosis/regurgitation, mitral regurgitation, etc.).",
  "Cardiac amyloidosis.",
  "Myocarditis (inflammation of the heart).",
  "Systemic inflammation (e.g., systemic sclerosis).",
  "Post-cancer chemotherapy, as chemotherapeutic agents can affect cardiac function. GLS is a well-established marker in this condition.",
  "GLS can predict heart failure in otherwise stable individuals."
      ],
      "keyBenefits": [
        "Early detection of heart muscle impairment",
        "More sensitive than conventional ejection fraction",
        "Objective quantification of myocardial function",
        "Better monitoring of treatment effects"
      ],
      "faqs": [
        {
          "question": "What is Global Longitudinal Strain?",
          "answer": "GLS measures the percentage change in length of myocardial fibers during contraction, providing a more sensitive measure of heart function than traditional ejection fraction."
        },
        {
          "question": "Who needs GLS 2D Echo?",
          "answer": "Patients receiving chemotherapy, those with early heart failure, athletes, and anyone needing sensitive assessment of myocardial function."
        }
      ]
    },
    {
      "name": "USG Abdomen Pelvis",
      "duration": "30-40 mins",
      "preparation": "6-8 hours fasting and full bladder required",
      "image": "https://media.istockphoto.com/id/508906957/photo/gall-bladder-ultrasound-with-doppler.jpg?s=612x612&w=0&k=20&c=N770-ojT9lwpuNx0k07UdXguhNN3RrHKczMhpiveruM=",
      "description": "Combined evaluation of abdominal and pelvic organs",
      "detailedDescription": [
        "Comprehensive assessment of liver, gallbladder, pancreas, spleen",
        "Evaluation of kidneys and urinary bladder",
        "Assessment of uterus, ovaries in females",
        "Evaluation of prostate in males",
        "Detection of abdominal and pelvic masses",
        "The female reproductive system is very important, and its health is crucial for reproductive capacity.",
  "It is necessary to study the female reproductive system periodically.",
  "One common test referred by gynecologists is USG Abdomen Pelvis.",
  "The pelvis comprises female pelvic organs and structures like the uterus, ovaries, fallopian tubes, vagina, and cervix.",
  "USG Abdomen Pelvis helps doctors and gynecologists to study, diagnose, and treat the pelvic and abdominal organs of females.",
  "A radiologist or sonographer performs the USG Abdomen Pelvis. A small amount of gel is applied to the abdomen to assist the ultrasound device in creating images.",
  "It is a simple test that takes about 20–40 minutes to perform."
      ],
      "keyBenefits": [
        "One-stop evaluation of entire abdomen and pelvis",
        "Comprehensive organ assessment",
        "No radiation exposure",
        "Cost-effective combined approach"
      ],
      "faqs": [
        {
          "question": "Why both fasting and full bladder?",
          "answer": "Fasting is for abdominal organs visualization, while full bladder is for pelvic organs assessment. This combination provides optimal conditions for both areas."
        },
        {
          "question": "Can this replace separate abdomen and pelvis scans?",
          "answer": "Yes, for comprehensive evaluation, this combined approach is often sufficient and more efficient than separate scans."
        }
      ]
    },
    {
      "name": "USG KUB PVR",
      "duration": "20-30 mins",
      "preparation": "Full bladder required, then post-void scan",
      "image": "https://media.istockphoto.com/id/1787707550/photo/usg-image-of-kub-normal-study.jpg?s=612x612&w=0&k=20&c=OWF_hqLB95TpPRe2YC0SRBGuIIxu1McoR4BcDb1UG7k=",
      "description": "Kidney, Ureter, Bladder scan with Post-Void Residual measurement",
      "detailedDescription": [
        "Evaluation of kidney size and parenchyma",
        "Detection of hydronephrosis and stones",
        "Assessment of bladder wall thickness",
        "Measurement of post-void residual urine",
        "Evaluation of urinary retention",
         "USG KUB is an ultrasound technique to examine and study the lower abdomen, specifically the kidneys, uterus, and urinary bladder (KUB).",
  "PVR stands for Post Residual Void, which measures the amount of urine left in the bladder after urination.",
  "Doctors often recommend KUB and PVR together to study the overall lower abdomen region.",
  "An experienced and qualified radiologist performs this test using a specific instrument on the lower abdomen.",
  "The procedure takes about 20–30 minutes to perform."
      ],
      "keyBenefits": [
        "Assessment of bladder emptying function",
        "Detection of urinary obstruction",
        "Evaluation of kidney function",
        "Monitoring of urinary retention"
      ],
      "faqs": [
        {
          "question": "What is PVR measurement?",
          "answer": "Post-Void Residual measures the amount of urine left in the bladder after urination, helping diagnose incomplete bladder emptying."
        },
        {
          "question": "Who needs KUB PVR ultrasound?",
          "answer": "Patients with urinary symptoms, elderly men with prostate issues, people with neurological conditions, or anyone with suspected bladder dysfunction."
        }
      ]
    },
    {
      "name": "Obstetrics Early",
      "duration": "20-30 mins",
      "preparation": "Full bladder recommended",
      "image": "https://media.istockphoto.com/id/859262198/photo/colourful-image-of-pregnancy-ultrasound-monitor.jpg?s=612x612&w=0&k=20&c=eW_QyO3OC-anVkRAsw7zvcEwlp_Lar4N7whon40xlpw=",
      "description": "First trimester pregnancy evaluation and dating",
      "detailedDescription": [
        "Confirmation of intrauterine pregnancy",
        "Detection of fetal heartbeat",
        "Accurate pregnancy dating",
        "Evaluation of early pregnancy complications",
        "Assessment of multiple pregnancies",
         "Ultrasound scans performed in early pregnancy are known as Obstetrics Early.",
  "This scan is done between 7–12 weeks of pregnancy.",
  "A full bladder is required to obtain clear ultrasound images.",
  "The procedure takes about 10–15 minutes to perform.",
  "It is a safe and painless test."
      ],
      "keyBenefits": [
        "Early pregnancy confirmation",
        "Detection of ectopic pregnancy",
        "Accurate due date estimation",
        "Peace of mind in early pregnancy"
      ],
      "faqs": [
        {
          "question": "When can fetal heartbeat be detected?",
          "answer": "Typically around 6 weeks gestation, though this can vary. Transvaginal ultrasound may detect it earlier than abdominal approach."
        },
        {
          "question": "Is early pregnancy ultrasound safe?",
          "answer": "Yes, ultrasound is considered safe throughout pregnancy, including the first trimester, with no known adverse effects."
        }
      ]
    },
    {
      "name": "Fetal Echocardiography",
      "duration": "45-60 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1187956544/photo/ultrasound-screen-with-fetal-echocardiography.jpg?s=612x612&w=0&k=20&c=rbt2u7CjidGebR13ANpqJw9IvRZzeP356CUjCVfY43I=",
      "description": "Detailed evaluation of fetal heart structure and function",
      "detailedDescription": [
        "Comprehensive assessment of fetal heart anatomy",
        "Evaluation of heart chamber connections",
        "Assessment of heart rate and rhythm",
        "Detection of congenital heart defects",
        "Evaluation of cardiac function and blood flow",
         "Fetal Echocardiography refers to the scan of the heart of the fetus/baby.",
  "It is performed in the second trimester, between the 18th and 24th week of pregnancy.",
  "This scan helps assess the growth and development of the fetal heart.",
  "The doctor can observe the blood flow within the heart of the fetus during the examination.",
  "The test helps detect any abnormalities in the heart and guides further necessary actions.",
  "The procedure takes about 30–120 minutes to perform.",
  "Fetal Echocardiography is safe and does not harm the pregnant woman or the fetus."
      ],
      "keyBenefits": [
        "Early detection of heart abnormalities",
        "Planning for delivery and postnatal care",
        "Family counseling and preparation",
        "Monitoring of known cardiac conditions"
      ],
      "faqs": [
        {
          "question": "When is fetal echo recommended?",
          "answer": "When there's family history of heart defects, maternal diabetes, abnormal routine ultrasound, or suspected fetal heart problems."
        },
        {
          "question": "Can all heart defects be detected before birth?",
          "answer": "While most major defects can be detected, some subtle abnormalities may not be apparent until after birth."
        }
      ]
    },
    {
      "name": "Growth Scan + BPP",
      "duration": "30-45 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1190394881/photo/the-beginning-of-a-beautiful-bond.jpg?s=612x612&w=0&k=20&c=inXMjjZTSZZ35X_p-9tWsDPze2yoBRd0YyN-ySrujY4=",
      "description": "Fetal growth assessment with Biophysical Profile",
      "detailedDescription": [
        "Measurement of fetal growth parameters",
        "Assessment of amniotic fluid volume",
        "Evaluation of fetal breathing movements",
        "Assessment of fetal tone and movements",
        "Non-stress test component if required",
         "Growth Scan refers to the scan done to check the growth of the baby.",
  "It is performed in the third (last) trimester, between the 28th and 32nd week of pregnancy.",
  "Growth Scan is a standard procedure to assess the growth and development of the baby.",
  "During the scan, radiologists check various parameters like the size of the baby’s head, blood flow, and the position of the baby in the placenta.",
  "The procedure takes about 30 minutes to perform.",
  "Along with the Growth Scan, doctors may recommend the BPP (Biophysical Profile) test to assess the health of the baby.",
  "BPP checks functions such as muscle tone, movement, heart rate, and breathing.",
  "The BPP test also takes about 30 minutes to perform.",
  "Both Growth Scan and BPP are safe for the pregnant woman and the baby."
      ],
      "keyBenefits": [
        "Comprehensive fetal well-being assessment",
        "Detection of growth restriction",
        "Evaluation of placental function",
        "Reassurance of fetal health"
      ],
      "faqs": [
        {
          "question": "What is Biophysical Profile (BPP)?",
          "answer": "BPP is a scoring system that evaluates fetal breathing, movements, tone, amniotic fluid, and sometimes heart rate reactivity to assess fetal well-being."
        },
        {
          "question": "When is Growth Scan + BPP done?",
          "answer": "Typically in third trimester for high-risk pregnancies, or when there are concerns about fetal growth or well-being."
        }
      ]
    },
    {
      "name": "Growth Scan 3D/4D",
      "duration": "45-60 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/516488283/photo/ultrasound-3d.jpg?s=612x612&w=0&k=20&c=HFBppdCzN1Ji05MiHGGDYJDw6zHXzu8HoOv5zYdDqeU=",
      "description": "Advanced fetal imaging with 3D/4D visualization",
      "detailedDescription": [
        "Measurement of fetal growth parameters",
        "3D surface rendering of fetal features",
        "Real-time 4D motion visualization",
        "Assessment of fetal anatomy with enhanced visualization",
        "Parental bonding experience",
        "3D/4D ultrasound helps get a better view and detailed assessment of the overall development of the baby.",
  "The reporting is done in the form of 3D/4D films.",
  "3D/4D scanning helps detect any issues in the growth of the baby.",
  "The scan takes a shorter duration to conduct.",
  "The scan reports are easy to understand."
      ],
      "keyBenefits": [
        "Enhanced visualization of fetal features",
        "Better detection of surface abnormalities",
        "Memorable parental experience",
        "Comprehensive growth assessment"
      ],
      "faqs": [
        {
          "question": "What is the best time for 3D/4D ultrasound?",
          "answer": "Between 26-32 weeks when the baby has developed fat but still has room to move, providing better images."
        },
        {
          "question": "Are 3D/4D images always clear?",
          "answer": "Image quality depends on factors like fetal position, amniotic fluid, maternal tissue, and fetal movement. Multiple attempts may be needed."
        }
      ]
    },
    {
      "name": "Obstetrics Doppler",
      "duration": "30-45 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/472649533/video/fetus-ultrasound-scan.jpg?s=640x640&k=20&c=_XohO5vvxZvN1wPFxYtApG8tguAhWXBN2GbnyKGPlHU=",
      "description": "Blood flow assessment in fetal and maternal vessels",
      "detailedDescription": [
        "Umbilical artery Doppler for placental function",
        "Middle cerebral artery Doppler for fetal anemia",
        "Uterine artery Doppler for pre-eclampsia risk",
        "Ductus venosus Doppler for cardiac assessment",
        "Comprehensive fetal well-being evaluation",
        "Doppler is a technique that uses sound waves to detect the movement of body objects.",
  "Doppler Ultrasound is used to examine the movement of blood within blood vessels.",
  "It helps study blood circulation in the uterus and placenta.",
  "The scan is performed in the third (last) trimester, between the 28th and 32nd week of pregnancy.",
  "The procedure takes about 30–60 minutes to perform.",
  "Obstetrics Doppler is safe and does not cause any harm to the pregnant woman or the baby."
      ],
      "keyBenefits": [
        "Assessment of placental function",
        "Detection of fetal anemia",
        "Evaluation of fetal well-being",
        "Guidance for pregnancy management"
      ],
      "faqs": [
        {
          "question": "When is obstetric Doppler needed?",
          "answer": "In cases of fetal growth restriction, maternal hypertension, diabetes, suspected fetal anemia, or decreased fetal movements."
        },
        {
          "question": "Is Doppler ultrasound safe in pregnancy?",
          "answer": "Yes, when used medically and for appropriate indications, Doppler ultrasound is considered safe with no known adverse effects."
        }
      ]
    },
    {
      "name": "Breast / Sonomammography",
      "duration": "30-45 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1485790369/photo/female-doctor-examines-woman-breasts-using-ultrasound-machine.jpg?s=612x612&w=0&k=20&c=CNVmtJ8iE8H-nkDMv6ryOtLrbXGs2YFY0vUjMeiPtcg=",
      "description": "Ultrasound evaluation of breast tissue",
      "detailedDescription": [
        "Evaluation of breast lumps and masses",
        "Characterization of solid vs. cystic lesions",
        "Assessment of breast pain and tenderness",
        "Evaluation of abnormal mammogram findings",
        "Guidance for breast biopsies",
         "To check whether the breast of females is in good condition, proper flow of blood is taking place inside the breast, & health of breast is very important.",
  "The procedure to check, diagnose and study healthy breasts is known as Sonomammography or Ultra Sound.",
  "The technique used for this is Imaging Technique. It is done in the form of an X-Ray of the breasts.",
  "Sonomammography also helps to detect, and examine for cancer and breast-related issues.",
  "Doctors advise Sonomammography when females complain about a breast lump or pain in the breast.",
  "It takes about 15-30 minutes to perform the same.",
  "It is a safe USG of the breast, not causing any harm to the female."
      ],
      "keyBenefits": [
        "No radiation exposure",
        "Excellent for dense breast tissue",
        "Real-time evaluation of breast lesions",
        "Guidance for interventional procedures"
      ],
      "faqs": [
        {
          "question": "Who needs breast ultrasound?",
          "answer": "Women with dense breasts, palpable lumps, breast pain, abnormal mammograms, or as supplemental screening in high-risk patients."
        },
        {
          "question": "Can ultrasound detect breast cancer?",
          "answer": "Yes, it can detect many breast cancers, especially in dense breast tissue where mammography may be less sensitive."
        }
      ]
    },
    {
      "name": "Neck / Thyroid",
      "duration": "20-30 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/812491804/photo/woman-holds-her-throat.jpg?s=612x612&w=0&k=20&c=9CGqaQbg8QCkQJFXxyiFwLJCQ2GxAIu1Bko0otSFdLc=",
      "description": "Comprehensive evaluation of thyroid gland and neck structures",
      "detailedDescription": [
        "Assessment of thyroid size, texture, and nodules",
        "Evaluation of parathyroid glands",
        "Detection of cervical lymph nodes",
        "Assessment of thyroiditis and Graves disease",
        "Guidance for thyroid fine needle aspiration",
        "An ultrasound imaging technique to check the structural assessment of the thyroid gland, that regulates metabolism, is known as USG Thyroid.",
  "Doctors recommend USG Thyroid when one sees symptoms like abnormal lymph in the area near the thyroid, or one feels that the size of the thyroid is big, or growth is noticed on the thyroid gland.",
  "USG Neck is an ultrasound imaging procedure that helps to check the blood vessels, tumors, glands, and other parts around the neck.",
  "To perform USG Neck, fasting for 4-6 hours is required.",
  "It takes about 15-30 minutes to perform the same.",
  "The report is received within 24 hours after conducting the procedure.",
  "It is a safe technique as this procedure does not use radiations. The ultrasound technique is used for this."
      ],
      "keyBenefits": [
        "Detailed thyroid anatomy visualization",
        "Characterization of thyroid nodules",
        "No radiation exposure",
        "Guidance for biopsies and treatments"
      ],
      "faqs": [
        {
          "question": "What thyroid conditions can ultrasound detect?",
          "answer": "Thyroid nodules, cysts, goiter, thyroiditis, cancer, and other structural abnormalities of the thyroid gland."
        },
        {
          "question": "Do all thyroid nodules need biopsy?",
          "answer": "No, only nodules with suspicious features on ultrasound or above certain size thresholds typically require biopsy."
        }
      ]
    },
    {
      "name": "Scrotum Ultrasound",
      "duration": "20-30 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1787709161/photo/usg-of-testes-smaller-both-testes-and-bilateral-mild-hydrocele-heterogeneous.jpg?s=612x612&w=0&k=20&c=wTzm0TsRtSkBgSmN5_Pfb0lW95Riei9JmTWVb_Qcl3A=",
      "description": "Detailed imaging of testicles and scrotal contents",
      "detailedDescription": [
        "Evaluation of testicular masses and tumors",
        "Assessment of testicular torsion and trauma",
        "Detection of varicoceles and hydroceles",
        "Evaluation of epididymitis and orchitis",
        "Assessment of undescended testicles",
        "To evaluate the testicle pain, swelling, or to detect a lump, a USG of the scrotum needs to be done.",
  "USG scrotum helps to examine the scrotum thoroughly.",
  "The imaging technique which uses sound waves to create pictures or photos of the male’s testicles is known as USG Scrotum.",
  "It takes about 30-40 minutes to perform the same.",
  "It is a safe technique as this procedure does not use radiation.",
  "Doppler is a way of using sound waves to detect the movement of other body objects.",
  "Doppler Ultrasound is a scan used to check the movement of the blood vessels.",
  "Scrotum Doppler is advised by doctors to study the flow of blood in the scrotum.",
  "Scrotum Doppler test helps to diagnose the disorder of the testicle",
  "It takes about 15-30 minutes to perform the same.",
  "This technique can be used and done as and when required, no limits are there for performing the same.",
  "It is a safe technique as this procedure"
      ],
      "keyBenefits": [
        "Quick assessment of scrotal emergencies",
        "Detailed testicular anatomy visualization",
        "No radiation exposure",
        "Guidance for urological treatments"
      ],
      "faqs": [
        {
          "question": "When is scrotal ultrasound needed?",
          "answer": "For testicular pain, swelling, palpable lumps, trauma, infertility evaluation, or suspected testicular torsion."
        },
        {
          "question": "Can it detect testicular cancer?",
          "answer": "Yes, ultrasound is the primary imaging modality for detecting and characterizing testicular masses and tumors."
        }
      ]
    },
    {
      "name": "Upper & Lower Limb Doppler",
      "duration": "45-60 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1491183871/photo/a-carotid-artery-doppler-ultrasound-is-a-diagnostic-test-used-to-check-the-arteries-in-the.jpg?s=612x612&w=0&k=20&c=e_AlFLEXmD89CYL228P8al3919TPErdtT_UMpBUkLrs=",
      "description": "Blood flow assessment in arm and leg vessels",
      "detailedDescription": [
        "Evaluation of deep vein thrombosis (DVT)",
        "Assessment of arterial insufficiency",
        "Detection of vascular malformations",
        "Evaluation of dialysis access fistulas",
        "Assessment of peripheral vascular disease",
         "An imaging technique that uses ultra sound to examine the upper and lower limb is known as Upper and Lower Limb USG.",
  "Doppler Ultrasound is a scan used to check the movement of the blood vessels.",
  "Upper and Lower Limb doppler helps to study the blood flow in the lower and upper limb by using high frequency waves.",
  "Mainly used to examine the blood flow in arteries and veins of the legs and arms.",
  "It is a safe and painless test.",
  "It takes only about 20–30 minutes to perform the same."
      ],
      "keyBenefits": [
        "Non-invasive vascular assessment",
        "Quick diagnosis of blood clots",
        "No radiation exposure",
        "Comprehensive limb vascular evaluation"
      ],
      "faqs": [
        {
          "question": "What symptoms require limb Doppler?",
          "answer": "Leg or arm swelling, pain, discoloration, coolness, ulcers, or suspected blood clots or arterial blockages."
        },
        {
          "question": "Can Doppler detect both arteries and veins?",
          "answer": "Yes, it can evaluate both arterial and venous systems, though the protocol may be optimized for one or the other based on clinical indication."
        }
      ]
    },
    {
      "name": "Obstetrics Twins USG",
      "duration": "45-60 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/2195869622/photo/ultrasography-animal-scan-image-after-30-weeks-of-pregnancy-show-normal-twin-babies.jpg?s=612x612&w=0&k=20&c=m_lruu8VdXXTlZ8Q7-rG5ZGMbgnDieXOvMDnVOqBqY4=",
      "description": "Specialized ultrasound for twin pregnancies",
      "detailedDescription": [
        "Determination of chorionicity and amnionicity",
        "Individual growth assessment of each twin",
        "Evaluation of twin-twin transfusion syndrome",
        "Assessment of amniotic fluid discordance",
        "Comprehensive well-being evaluation of both fetuses",
        "Ultrasound scans which are done in the to detect whether the uterus is carrying more than 1 foetus is known as Obstetrics Twin USG.",
  "This scan is done between 10-12 weeks of the pregnancy.",
  "It takes about 45–60 minutes to perform the same. It requires more time as there are two foetus to be scanned."
      ],
      "keyBenefits": [
        "Early detection of twin complications",
        "Individual growth monitoring",
        "Assessment of placental sharing",
        "Guidance for twin pregnancy management"
      ],
      "faqs": [
        {
          "question": "Why is twin ultrasound different?",
          "answer": "Twin pregnancies require special attention to chorionicity, growth discordance, and complications like twin-twin transfusion syndrome."
        },
        {
          "question": "How often are twin ultrasounds done?",
          "answer": "Typically more frequently than singleton pregnancies, often every 2-4 weeks in the second and third trimesters."
        }
      ]
    },
    {
      "name": "Shear Wave Elastography",
      "duration": "30-45 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/2247638509/photo/detailed-color-doppler-ultrasound-study-of-the-carotid-artery-showing-evidence-of.jpg?s=612x612&w=0&k=20&c=L0QmyTLy-70lDJywQRHGBWPbIB87sxscpJeS0AlhHj0=",
      "description": "Advanced tissue stiffness measurement using ultrasound",
      "detailedDescription": [
        "Quantitative assessment of tissue elasticity",
        "Evaluation of liver fibrosis without biopsy",
        "Characterization of thyroid and breast lesions",
        "Assessment of musculoskeletal tissue stiffness",
        "Monitoring treatment response in chronic diseases"
      ],
      "keyBenefits": [
        "Non-invasive alternative to biopsy",
        "Quantitative tissue characterization",
        "Early detection of fibrosis",
        "Improved lesion characterization"
      ],
      "faqs": [
        {
          "question": "What is elastography used for?",
          "answer": "Primarily for liver fibrosis staging, but also for characterizing tumors in breast, thyroid, prostate, and assessing musculoskeletal tissues."
        },
        {
          "question": "Is it better than regular ultrasound?",
          "answer": "It provides additional functional information about tissue stiffness that complements conventional ultrasound imaging for better diagnostic accuracy."
        }
      ]
    }
  ]
},

  {
  "id": "pathology",
  "name": "PATHOLOGY LAB",
  "icon": "lab",
  "description": "Comprehensive diagnostic laboratory services with advanced testing capabilities and accurate results",
  "image": "https://media.istockphoto.com/id/1387090964/photo/doctor-working-with-microplate-for-elisa-analysis.jpg?s=612x612&w=0&k=20&c=sbADxpHinS4j7MUZUh1LROB-4qRnTLmE0Oln_upD7iA=",
  "details": "Our state-of-the-art pathology laboratory offers a complete range of diagnostic tests with advanced automated analyzers and stringent quality control. Equipped with latest generation technology for precise and timely results.",
  "keyFeatures": [
    "NABL accredited laboratory",
    "Advanced automated analyzers",
    "Rapid turnaround time",
    "Highly qualified pathologists",
    "Stringent quality control",
    "Digital report delivery"
  ],
  "subServices": [
    {
      "name": "Haemogram/CBC",
      "duration": "2-4 hours",
      "preparation": "No fasting required",
      "image": "https://media.istockphoto.com/id/1344878044/photo/blood-sample-tube-for-haemogram-or-complete-blood-cell-test.jpg?s=612x612&w=0&k=20&c=R5OHq2cDunXrzsb5o_6oL8SSz9RAe820xhtHp8XOjfk=",
      "description": "Complete Blood Count for comprehensive evaluation of blood cells",
      "detailedDescription": [
        "Complete red blood cell count and indices",
        "White blood cell count and differential",
        "Platelet count and morphology",
        "Hemoglobin and hematocrit measurement",
        "Detection of anemia, infections, and blood disorders"
      ],
      "keyBenefits": [
        "Comprehensive blood health assessment",
        "Early detection of infections",
        "Monitoring of blood disorders",
        "Baseline health screening"
      ],
      "faqs": [
        {
          "question": "What does CBC test for?",
          "answer": "CBC evaluates overall health and detects various disorders including anemia, infection, leukemia, and other blood-related conditions."
        },
        {
          "question": "Is fasting required for CBC?",
          "answer": "No, fasting is not required for Complete Blood Count. You can take the test at any time of the day."
        }
      ]
    },
    {
      "name": "Urine Routine",
      "duration": "2-4 hours",
      "preparation": "First morning urine sample preferred",
      "image": "https://media.istockphoto.com/id/826977922/photo/doctor-holding-a-container-in-hand-isolated-on-white-background-urine-sample-test.jpg?s=612x612&w=0&k=20&c=EvuG1zOflirsyDkCesiyZbiIAZBbbWlQjkHmKQ3Bq8g=",
      "description": "Complete urine analysis for kidney function and urinary tract health",
      "detailedDescription": [
        "Physical examination of color and appearance",
        "Chemical analysis for pH, protein, glucose",
        "Microscopic examination for cells and casts",
        "Detection of urinary tract infections",
        "Assessment of kidney function"
      ],
      "keyBenefits": [
        "Early detection of kidney diseases",
        "Urinary tract infection diagnosis",
        "Diabetes monitoring",
        "Liver function assessment"
      ],
      "faqs": [
        {
          "question": "What is the best time to collect urine sample?",
          "answer": "First morning urine is preferred as it is more concentrated and provides more accurate results for most parameters."
        },
        {
          "question": "How much urine is needed for the test?",
          "answer": "Typically 10-15 ml of urine in a sterile container is sufficient for complete analysis."
        }
      ]
    },
    {
      "name": "BSL (Blood Sugar Levels)",
      "duration": "2-4 hours",
      "preparation": "Fasting required for FBS, no fasting for random",
      "image": "https://media.istockphoto.com/id/1329877512/photo/blood-glucose-meter-the-blood-sugar-value-is-measured-on-a-finger-on-yellow-background.jpg?s=612x612&w=0&k=20&c=c6DVSFCP3r3M8k0HYFw1l3NXnq67EODmZXHlCTekDwc=",
      "description": "Blood glucose measurement for diabetes screening and management",
      "detailedDescription": [
        "Fasting Blood Sugar (FBS) assessment",
        "Postprandial Blood Sugar (PPBS) evaluation",
        "Random Blood Sugar monitoring",
        "Diabetes diagnosis and management",
        "Hypoglycemia detection"
      ],
      "keyBenefits": [
        "Early diabetes detection",
        "Effective diabetes management",
        "Hypoglycemia diagnosis",
        "Metabolic health assessment"
      ],
      "faqs": [
        {
          "question": "How long should I fast for FBS test?",
          "answer": "Typically 8-12 hours of fasting is required. Only water is allowed during the fasting period."
        },
        {
          "question": "What is the normal blood sugar range?",
          "answer": "Fasting: 70-100 mg/dL, Postprandial (2 hours): <140 mg/dL, Random: <140 mg/dL (may vary slightly by laboratory)."
        }
      ]
    },
    {
      "name": "Blood Group",
      "duration": "2-3 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1068482588/photo/donate-blood-group-doctor.jpg?s=612x612&w=0&k=20&c=fMMGby4lyTuCay0aNDrPpWkin7S2Q7LurTSdlXq4yo4=",
      "description": "Determination of ABO and Rh blood group system",
      "detailedDescription": [
        "ABO blood group identification (A, B, AB, O)",
        "Rh factor determination (Positive/Negative)",
        "Cross-matching compatibility testing",
        "Blood donor screening",
        "Pregnancy Rh compatibility assessment"
      ],
      "keyBenefits": [
        "Essential for blood transfusions",
        "Pregnancy management",
        "Emergency preparedness",
        "Surgical planning"
      ],
      "faqs": [
        {
          "question": "Why is knowing blood group important?",
          "answer": "It's crucial for safe blood transfusions, organ transplants, pregnancy management, and emergency medical situations."
        },
        {
          "question": "Can blood group change over time?",
          "answer": "No, blood group is genetically determined and remains the same throughout life, except in rare cases of bone marrow transplant."
        }
      ]
    },
    {
      "name": "Lipid Profile",
      "duration": "4-6 hours",
      "preparation": "12-14 hours fasting required",
      "image": "https://media.istockphoto.com/id/1351786945/photo/lipid-profile-test-at-medical-laboratory.jpg?s=612x612&w=0&k=20&c=9whCexNz1_eJpkKERSzeDuLgJJ4MBF4-qsyGObCnzLY=",
      "description": "Comprehensive assessment of cholesterol and triglyceride levels",
      "detailedDescription": [
        "Total cholesterol measurement",
        "HDL (good cholesterol) assessment",
        "LDL (bad cholesterol) calculation",
        "Triglycerides evaluation",
        "Cardiovascular risk assessment"
      ],
      "keyBenefits": [
        "Heart disease risk assessment",
        "Cholesterol management monitoring",
        "Preventive health screening",
        "Treatment effectiveness evaluation"
      ],
      "faqs": [
        {
          "question": "Why is fasting required for lipid profile?",
          "answer": "Fasting ensures accurate triglyceride measurement as recent meals can significantly affect triglyceride levels."
        },
        {
          "question": "How often should lipid profile be done?",
          "answer": "Adults should get tested every 4-6 years. More frequently if you have risk factors or are on cholesterol medication."
        }
      ]
    },
    {
      "name": "Liver Function Test (LFT)",
      "duration": "4-6 hours",
      "preparation": "Fasting recommended but not mandatory",
      "image": "https://media.istockphoto.com/id/1405598546/photo/blood-sample-isolated-for-liver-function-test-including-alt-ast-alp-and-total-bilirubin-with.jpg?s=612x612&w=0&k=20&c=f0FLZeqlM3ZpfRHN8X7BhAmmaXyVokhSG0geBnasMdI=",
      "description": "Comprehensive panel to assess liver health and function",
      "detailedDescription": [
        "Liver enzymes assessment (ALT, AST, ALP)",
        "Bilirubin total and direct measurement",
        "Total protein and albumin evaluation",
        "Liver synthetic function assessment",
        "Detection of liver inflammation and damage"
      ],
      "keyBenefits": [
        "Early detection of liver diseases",
        "Hepatitis monitoring",
        "Alcohol-related liver damage assessment",
        "Medication toxicity evaluation"
      ],
      "faqs": [
        {
          "question": "What conditions can LFT detect?",
          "answer": "Hepatitis, cirrhosis, fatty liver disease, gallstones, liver cancer, and medication-induced liver damage."
        },
        {
          "question": "Should I avoid medications before LFT?",
          "answer": "Inform your doctor about all medications. Some may need to be temporarily stopped as they can affect liver enzymes."
        }
      ]
    },
    {
      "name": "TFT (Thyroid Function Test)",
      "duration": "4-6 hours",
      "preparation": "No fasting required, better in morning",
      "image": "https://media.istockphoto.com/id/951171904/photo/thyroid-profile-test.jpg?s=612x612&w=0&k=20&c=IlY8Qr_CbzVc-KJbZw3aRWtYcF6KX0mNAP4HWHHZWVM=",
      "description": "Comprehensive thyroid hormone assessment including T3, T4, TSH",
      "detailedDescription": [
        "TSH (Thyroid Stimulating Hormone) measurement",
        "Free T3 and Free T4 level assessment",
        "Thyroid gland function evaluation",
        "Hyperthyroidism and hypothyroidism diagnosis",
        "Thyroid treatment monitoring"
      ],
      "keyBenefits": [
        "Accurate thyroid disorder diagnosis",
        "Treatment effectiveness monitoring",
        "Metabolic rate assessment",
        "Fertility and pregnancy thyroid monitoring"
      ],
      "faqs": [
        {
          "question": "What are symptoms of thyroid problems?",
          "answer": "Weight changes, fatigue, mood swings, hair loss, temperature sensitivity, and heart rate changes may indicate thyroid issues."
        },
        {
          "question": "Is morning the best time for thyroid test?",
          "answer": "Yes, TSH levels are highest in the morning, providing the most accurate assessment of thyroid function."
        }
      ]
    },
    {
      "name": "Kidney Profile (KFT)",
      "duration": "4-6 hours",
      "preparation": "Fasting recommended for accurate results",
      "image": "https://media.istockphoto.com/id/1470718218/video/kidney-function-test-to-look-for-abnormalities-from-blood.jpg?s=640x640&k=20&c=n5AUN80jUONCco1kWbPl7nTGvEDlOV4ClGia4vymWww=",
      "description": "Comprehensive assessment of kidney function and health",
      "detailedDescription": [
        "Blood Urea Nitrogen (BUN) measurement",
        "Serum creatinine level assessment",
        "Uric acid evaluation",
        "Electrolyte balance assessment",
        "Glomerular filtration rate (GFR) calculation"
      ],
      "keyBenefits": [
        "Early detection of kidney disease",
        "Diabetes kidney complication monitoring",
        "Hypertension kidney damage assessment",
        "Medication toxicity evaluation"
      ],
      "faqs": [
        {
          "question": "What is normal creatinine level?",
          "answer": "Typically 0.6-1.2 mg/dL for men and 0.5-1.1 mg/dL for women, but ranges may vary slightly between laboratories."
        },
        {
          "question": "How can I improve my kidney function?",
          "answer": "Stay hydrated, control blood pressure and diabetes, avoid NSAIDs, reduce salt intake, and maintain healthy weight."
        }
      ]
    },
    {
      "name": "ESR",
      "duration": "2-3 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1347709306/photo/blood-sample-for-erythrocyte-sedimentation-rate-test-medical-test-tube-in-laboratory.jpg?s=612x612&w=0&k=20&c=gTIQyclWnc3ykOWWzWUHhkNjrrRfR-BscT3UVS7BPtc=",
      "description": "Erythrocyte Sedimentation Rate for inflammation assessment",
      "detailedDescription": [
        "Measurement of red blood cell settling rate",
        "Non-specific inflammation marker",
        "Infection and autoimmune disease screening",
        "Temporal arteritis and polymyalgia rheumatica monitoring",
        "Treatment response assessment"
      ],
      "keyBenefits": [
        "Inflammation detection",
        "Autoimmune disease screening",
        "Infection monitoring",
        "Treatment effectiveness evaluation"
      ],
      "faqs": [
        {
          "question": "What causes high ESR?",
          "answer": "Infections, autoimmune diseases, cancers, kidney disease, thyroid problems, and aging can increase ESR levels."
        },
        {
          "question": "Is ESR test specific for any disease?",
          "answer": "No, ESR is a non-specific test that indicates inflammation but doesn't identify the specific cause or location."
        }
      ]
    },
    {
      "name": "Malaria Antigen",
      "duration": "2-4 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1365453539/photo/positive-malaria-rapid-diagnostic-test-result-by-using-rapid-testing-cassette.jpg?s=612x612&w=0&k=20&c=SDc6lly8VJ5lKxcihNDunql9A5x9R2fRLvSQGhxt-0o=",
      "description": "Rapid detection of malaria parasites in blood",
      "detailedDescription": [
        "Detection of Plasmodium species antigens",
        "Rapid diagnostic test for malaria",
        "Species identification in some tests",
        "Early malaria diagnosis",
        "Treatment monitoring"
      ],
      "keyBenefits": [
        "Rapid malaria diagnosis",
        "Early treatment initiation",
        "Species identification",
        "High sensitivity and specificity"
      ],
      "faqs": [
        {
          "question": "How soon after fever should malaria test be done?",
          "answer": "Test should be done immediately when malaria is suspected, as early diagnosis improves treatment outcomes."
        },
        {
          "question": "Can malaria test be false negative?",
          "answer": "Yes, if parasite load is low or if test is done too early in infection. Repeat testing may be needed if symptoms persist."
        }
      ]
    },
    {
      "name": "Semen Analysis",
      "duration": "24-48 hours",
      "preparation": "3-5 days abstinence required",
      "image": "https://media.istockphoto.com/id/1165744638/photo/doctor-in-blue-uniform-and-latex-gloves-is-holding-an-empty-plastic-container-for-taking.jpg?s=612x612&w=0&k=20&c=pXMryWZSQTIK2BsWy929pYWRxpTLdFgacvMgzjRHVt4=",
      "description": "Comprehensive evaluation of semen quality and sperm parameters",
      "detailedDescription": [
        "Sperm count and concentration measurement",
        "Sperm motility and progression assessment",
        "Sperm morphology evaluation",
        "Semen volume and viscosity measurement",
        "Fertility potential assessment"
      ],
      "keyBenefits": [
        "Male fertility assessment",
        "Infertility cause identification",
        "Treatment planning guidance",
        "Vasectomy success verification"
      ],
      "faqs": [
        {
          "question": "How long should I abstain before semen analysis?",
          "answer": "Typically 3-5 days of sexual abstinence is recommended for optimal sample quality and accurate results."
        },
        {
          "question": "What if my semen analysis is abnormal?",
          "answer": "Abnormal results don't necessarily mean infertility. Repeat testing and consultation with a fertility specialist is recommended."
        }
      ]
    },
    {
      "name": "HbA1c",
      "duration": "4-6 hours",
      "preparation": "No fasting required",
      "image": "https://media.istockphoto.com/id/859386294/photo/hba1c-test.jpg?s=612x612&w=0&k=20&c=ZmG8CkIBXogLHfzx_K10n-rMsGkEKRh3Ln-m-q9lrnw=",
      "description": "Glycated Hemoglobin test for 3-month average blood sugar control",
      "detailedDescription": [
        "Measurement of glucose attached to hemoglobin",
        "3-month average blood sugar assessment",
        "Diabetes diagnosis and monitoring",
        "Treatment effectiveness evaluation",
        "Long-term complication risk assessment"
      ],
      "keyBenefits": [
        "Long-term diabetes monitoring",
        "No fasting requirement",
        "Not affected by recent meals",
        "Accurate diabetes diagnosis"
      ],
      "faqs": [
        {
          "question": "What is normal HbA1c level?",
          "answer": "Normal: Below 5.7%, Prediabetes: 5.7-6.4%, Diabetes: 6.5% or higher. Target for diabetics is usually below 7%."
        },
        {
          "question": "How often should HbA1c be tested?",
          "answer": "Diabetics: Every 3-6 months, Prediabetics: Every year, Normal individuals: Every 3 years after age 45."
        }
      ]
    },
    {
      "name": "HIV",
      "duration": "24-48 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/903375720/photo/hiv-positive-blood-sample.jpg?s=612x612&w=0&k=20&c=iAf5GQJ-Itpqv3TnbCIdk3585IuhkYptZF6-rEpHYWA=",
      "description": "Human Immunodeficiency Virus screening and confirmation",
      "detailedDescription": [
        "HIV antibody and antigen screening",
        "Fourth generation combination test",
        "Western blot confirmation if positive",
        "Early detection capability",
        "Confidential testing with counseling"
      ],
      "keyBenefits": [
        "Early HIV detection",
        "Fourth generation high accuracy",
        "Confidential testing",
        "Pre- and post-test counseling"
      ],
      "faqs": [
        {
          "question": "How soon after exposure can HIV be detected?",
          "answer": "Fourth generation tests can detect HIV as early as 2-4 weeks after exposure, but 3 months is recommended for conclusive results."
        },
        {
          "question": "Is HIV testing confidential?",
          "answer": "Yes, all HIV testing is completely confidential with pre-test and post-test counseling provided."
        }
      ]
    },
    {
      "name": "HCV",
      "duration": "24-48 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/862396010/photo/hepatitis-c-positive.jpg?s=612x612&w=0&k=20&c=9Da-CblOCTh3N9EOZ64GfcQckr_gOvj6xZi1XglZR4A=",
      "description": "Hepatitis C Virus antibody screening and RNA detection",
      "detailedDescription": [
        "HCV antibody screening test",
        "HCV RNA PCR for confirmation",
        "Viral load quantification",
        "Genotype determination if positive",
        "Treatment monitoring"
      ],
      "keyBenefits": [
        "Early hepatitis C detection",
        "Treatment guidance",
        "Cure confirmation",
        "Liver disease prevention"
      ],
      "faqs": [
        {
          "question": "Who should get tested for HCV?",
          "answer": "Baby boomers (born 1945-1965), people with history of blood transfusion before 1992, IV drug users, and healthcare workers."
        },
        {
          "question": "Can hepatitis C be cured?",
          "answer": "Yes, modern antiviral treatments can cure over 95% of Hepatitis C infections with minimal side effects."
        }
      ]
    },
    {
      "name": "HbsAg",
      "duration": "24-48 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/2158234532/photo/scientist-holding-in-hand-a-positive-hbsab-test.jpg?s=612x612&w=0&k=20&c=aY7sFtB44jovuQUlkNj2I4cFtuMSgtGSNrsMYCeOAaM=",
      "description": "Hepatitis B Surface Antigen test for hepatitis B infection",
      "detailedDescription": [
        "Hepatitis B surface antigen detection",
        "Acute and chronic hepatitis B diagnosis",
        "Carrier state identification",
        "Vaccination need assessment",
        "Liver disease risk evaluation"
      ],
      "keyBenefits": [
        "Early hepatitis B detection",
        "Carrier identification",
        "Vaccination guidance",
        "Liver cancer prevention"
      ],
      "faqs": [
        {
          "question": "What does positive HbsAg mean?",
          "answer": "Positive HbsAg indicates current hepatitis B infection, either acute or chronic. Further tests are needed to determine the stage."
        },
        {
          "question": "How is hepatitis B different from hepatitis C?",
          "answer": "Hepatitis B is DNA virus with vaccine available, while Hepatitis C is RNA virus with no vaccine but highly curable treatments."
        }
      ]
    },
    {
      "name": "VDRL",
      "duration": "24-48 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1347708918/photo/biochemist-or-lab-technologist-holds-blood-samples-for-vdrl-test-diagnosis-for-syphilis.jpg?s=612x612&w=0&k=20&c=ofRJog5cklQUIERKDO0L1Bs0BocqRhVdO_VVZSF0w_4=",
      "description": "Syphilis screening test for Treponema pallidum infection",
      "detailedDescription": [
        "Non-treponemal syphilis screening",
        "Antibody detection for syphilis",
        "Disease activity monitoring",
        "Treatment response assessment",
        "Pregnancy screening"
      ],
      "keyBenefits": [
        "Syphilis screening",
        "Treatment monitoring",
        "Pregnancy safety assessment",
        "Public health protection"
      ],
      "faqs": [
        {
          "question": "What is VDRL test used for?",
          "answer": "Screening for syphilis, monitoring treatment response, and routine pregnancy screening to prevent congenital syphilis."
        },
        {
          "question": "Can VDRL be false positive?",
          "answer": "Yes, conditions like pregnancy, autoimmune diseases, infections, and vaccinations can cause false positive VDRL results."
        }
      ]
    },
    {
      "name": "TSH",
      "duration": "4-6 hours",
      "preparation": "No fasting required, morning test preferred",
      "image": "https://media.istockphoto.com/id/951171904/photo/thyroid-profile-test.jpg?s=612x612&w=0&k=20&c=IlY8Qr_CbzVc-KJbZw3aRWtYcF6KX0mNAP4HWHHZWVM=",
      "description": "Thyroid Stimulating Hormone measurement for thyroid function screening",
      "detailedDescription": [
        "Pituitary gland function assessment",
        "Primary thyroid disorder screening",
        "Hypothyroidism and hyperthyroidism detection",
        "Thyroid medication monitoring",
        "Most sensitive thyroid function indicator"
      ],
      "keyBenefits": [
        "Most sensitive thyroid test",
        "Early thyroid disorder detection",
        "Treatment monitoring",
        "Comprehensive thyroid assessment"
      ],
      "faqs": [
        {
          "question": "Why is TSH the first thyroid test?",
          "answer": "TSH is the most sensitive indicator of thyroid function and can detect abnormalities even before T3 and T4 levels change."
        },
        {
          "question": "What is normal TSH level?",
          "answer": "Typically 0.4-4.0 mIU/L, but optimal range may be narrower. Interpretation should consider clinical context."
        }
      ]
    },
    {
      "name": "Serum Electrolytes (Na+K+Cl)",
      "duration": "4-6 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1502729785/photo/lab-technician-hand-checking-patient-blood-tube-before-submitting-test.jpg?s=612x612&w=0&k=20&c=AUB4I6TtISjWBsEZu_fqecQaaNZNTPBqt4ATxG7_6PY=",
      "description": "Measurement of sodium, potassium, and chloride levels in blood",
      "detailedDescription": [
        "Sodium level assessment for fluid balance",
        "Potassium measurement for heart and muscle function",
        "Chloride evaluation for acid-base balance",
        "Dehydration and overhydration assessment",
        "Kidney and adrenal function evaluation"
      ],
      "keyBenefits": [
        "Fluid balance assessment",
        "Heart rhythm monitoring",
        "Kidney function evaluation",
        "Critical care management"
      ],
      "faqs": [
        {
          "question": "What causes electrolyte imbalance?",
          "answer": "Dehydration, kidney disease, heart failure, medications, vomiting, diarrhea, and hormonal disorders can disrupt electrolyte balance."
        },
        {
          "question": "Are electrolyte tests important for athletes?",
          "answer": "Yes, athletes often need electrolyte monitoring due to significant fluid and electrolyte loss through sweating during intense exercise."
        }
      ]
    },
    {
      "name": "Vitamin B12",
      "duration": "24-48 hours",
      "preparation": "Fasting recommended for accurate results",
      "image": "https://media.istockphoto.com/id/1221896059/photo/vitamin-b12-test.jpg?s=612x612&w=0&k=20&c=y6AewfYbGaofJvftaL0Y0r7axxc3PmHH89LitNkM5Oc=",
      "description": "Measurement of Vitamin B12 levels for deficiency assessment",
      "detailedDescription": [
        "Cobalamin level measurement",
        "Megaloblastic anemia diagnosis",
        "Neurological function assessment",
        "Vegetarian and vegan diet monitoring",
        "Malabsorption syndrome evaluation"
      ],
      "keyBenefits": [
        "Anemia cause identification",
        "Neurological health assessment",
        "Dietary adequacy evaluation",
        "Treatment monitoring"
      ],
      "faqs": [
        {
          "question": "Who is at risk for B12 deficiency?",
          "answer": "Vegetarians, vegans, elderly, people with gastrointestinal disorders, and those taking certain medications like metformin."
        },
        {
          "question": "What are symptoms of B12 deficiency?",
          "answer": "Fatigue, weakness, numbness, memory problems, depression, and megaloblastic anemia are common symptoms."
        }
      ]
    },
    {
      "name": "Vitamin D3",
      "duration": "24-48 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1330728771/photo/woman-scientist-in-lab-look-at-science-microscope-medical-test-and-research-biology-chemistry.jpg?s=612x612&w=0&k=20&c=NecvyfqstYEqoZNBgoitL1WkdrtRyVzFwr8orEgorFw=",
      "description": "25-Hydroxy Vitamin D measurement for bone health and immunity",
      "detailedDescription": [
        "25-OH Vitamin D level assessment",
        "Bone health evaluation",
        "Immune function assessment",
        "Calcium metabolism evaluation",
        "Deficiency and insufficiency diagnosis"
      ],
      "keyBenefits": [
        "Bone health assessment",
        "Immune function evaluation",
        "Deficiency diagnosis",
        "Supplementation guidance"
      ],
      "faqs": [
        {
          "question": "What is optimal Vitamin D level?",
          "answer": "Sufficient: 20-50 ng/mL, Optimal: 30-50 ng/mL, Deficient: Below 20 ng/mL. Levels above 100 ng/mL may be toxic."
        },
        {
          "question": "How can I increase Vitamin D levels?",
          "answer": "Sun exposure, fatty fish, fortified foods, and supplements. Consult your doctor for appropriate dosage."
        }
      ]
    },
    {
      "name": "Double Marker",
      "duration": "48-72 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1513832109/video/motherhood-icon-animation.jpg?s=640x640&k=20&c=6iWRmwkkszPoctv-EbSusA6K-9XwkuYP6E-R8Wkr7lg=",
      "description": "First trimester prenatal screening for chromosomal abnormalities",
      "detailedDescription": [
        "Pregnancy Associated Plasma Protein A (PAPP-A) measurement",
        "Free Beta hCG assessment",
        "Combined with NT scan for risk calculation",
        "Down syndrome risk assessment",
        "Trisomy 18 and 13 screening"
      ],
      "keyBenefits": [
        "Early Down syndrome screening",
        "Non-invasive prenatal testing",
        "High detection rate",
        "Informed pregnancy decisions"
      ],
      "faqs": [
        {
          "question": "When is double marker test done?",
          "answer": "Between 11 weeks and 13 weeks 6 days of pregnancy, ideally combined with nuchal translucency ultrasound."
        },
        {
          "question": "Is double marker test diagnostic?",
          "answer": "No, it's a screening test that provides risk assessment. Diagnostic tests like CVS or amniocentesis are needed for confirmation."
        }
      ]
    },
    {
      "name": "Rubella IgG",
      "duration": "24-48 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1395990070/photo/blood-sample-for-rubella-antibody-test-rubella-blood-test.jpg?s=612x612&w=0&k=20&c=xqEdxhqazWf9QLfs0VlwC-0QcIZDLIMCNg5CDB-0qFI=",
      "description": "Immunity status assessment for German measles (Rubella)",
      "detailedDescription": [
        "Rubella antibody level measurement",
        "Immunity status determination",
        "Vaccination need assessment",
        "Pre-pregnancy screening",
        "Congenital rubella syndrome prevention"
      ],
      "keyBenefits": [
        "Immunity status verification",
        "Pregnancy safety assessment",
        "Vaccination guidance",
        "Congenital defect prevention"
      ],
      "faqs": [
        {
          "question": "Why is Rubella IgG important before pregnancy?",
          "answer": "Rubella infection during pregnancy can cause serious birth defects. Immunity verification ensures protection."
        },
        {
          "question": "What if Rubella IgG is negative?",
          "answer": "Vaccination is recommended at least one month before pregnancy to ensure immunity and protect the baby."
        }
      ]
    },
    {
      "name": "Rubella IgM",
      "duration": "24-48 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/2202308278/photo/blood-sample-for-rubella-igm-test.jpg?s=612x612&w=0&k=20&c=gmMmeLmbGIyRunpo7nhP-SpPltA_3CpGfMEWF_4IKxA=",
      "description": "Detection of recent Rubella infection",
      "detailedDescription": [
        "Acute Rubella infection detection",
        "Recent exposure assessment",
        "Pregnancy risk evaluation",
        "Infection timing determination",
        "Public health management"
      ],
      "keyBenefits": [
        "Recent infection detection",
        "Pregnancy risk assessment",
        "Outbreak investigation",
        "Appropriate management guidance"
      ],
      "faqs": [
        {
          "question": "When is Rubella IgM positive?",
          "answer": "IgM antibodies appear 1-2 weeks after infection and persist for 6-12 weeks, indicating recent or current infection."
        },
        {
          "question": "What if pregnant woman has positive Rubella IgM?",
          "answer": "Immediate consultation with obstetrician and infectious disease specialist is crucial for risk assessment and management."
        }
      ]
    },
    {
      "name": "D-dimer",
      "duration": "2-4 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1917623995/photo/doctor-holding-a-test-blood-sample-tube-with-d-dimer-test-on-the-background-of-medical-test.jpg?s=612x612&w=0&k=20&c=ARswA1V0g9utzSFoB5PMxPQVLLGxQiMaXv6WMpZzidY=",
      "description": "Fibrin degradation product measurement for blood clot detection",
      "detailedDescription": [
        "Fibrin degradation product assessment",
        "Deep vein thrombosis (DVT) screening",
        "Pulmonary embolism (PE) evaluation",
        "Disseminated intravascular coagulation (DIC) diagnosis",
        "Thrombotic events monitoring"
      ],
      "keyBenefits": [
        "Rapid blood clot detection",
        "Emergency diagnosis assistance",
        "Treatment monitoring",
        "High negative predictive value"
      ],
      "faqs": [
        {
          "question": "What does elevated D-dimer mean?",
          "answer": "Elevated D-dimer suggests possible blood clot formation, but can also be raised in pregnancy, inflammation, cancer, and after surgery."
        },
        {
          "question": "Is D-dimer test specific for DVT/PE?",
          "answer": "No, it's sensitive but not specific. Positive result requires confirmation with imaging studies like ultrasound or CT angiography."
        }
      ]
    },
    {
      "name": "LDH",
      "duration": "4-6 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1084573046/photo/blood-for-lactate-dehydrogenase-or-ldh-test.jpg?s=612x612&w=0&k=20&c=QksujuXokGDip2iDdaqotWyciw14D7bJ_PqjzyfEQl8=",
      "description": "Lactate Dehydrogenase measurement for tissue damage assessment",
      "detailedDescription": [
        "Total LDH level measurement",
        "Tissue damage marker",
        "Hemolysis detection",
        "Cancer monitoring",
        "Heart attack and liver disease assessment"
      ],
      "keyBenefits": [
        "Tissue damage assessment",
        "Disease monitoring",
        "Treatment response evaluation",
        "Prognostic indicator"
      ],
      "faqs": [
        {
          "question": "What conditions increase LDH levels?",
          "answer": "Heart attack, liver disease, muscle injury, hemolysis, cancers, infections, and any condition causing tissue damage."
        },
        {
          "question": "Is LDH test specific for any disease?",
          "answer": "No, LDH is a non-specific marker of tissue damage. Further testing is needed to identify the specific cause."
        }
      ]
    },
    {
      "name": "CRP",
      "duration": "4-6 hours",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1005170856/photo/c-reactive-protein-test.jpg?s=612x612&w=0&k=20&c=Zyi54VmOaRLcWG6ceHWseBvgVdd9KuYniP5naoCLm0k=",
      "description": "C-Reactive Protein measurement for inflammation assessment",
      "detailedDescription": [
        "Acute phase protein measurement",
        "Inflammation marker assessment",
        "Infection detection",
        "Cardiovascular risk assessment (hs-CRP)",
        "Treatment response monitoring"
      ],
      "keyBenefits": [
        "Inflammation detection",
        "Infection monitoring",
        "Cardiovascular risk assessment",
        "Treatment effectiveness evaluation"
      ],
      "faqs": [
        {
          "question": "What is the difference between CRP and hs-CRP?",
          "answer": "Regular CRP measures significant inflammation/infection, while hs-CRP (high-sensitivity) detects low-grade inflammation for cardiac risk assessment."
        },
        {
          "question": "What causes high CRP?",
          "answer": "Infections, autoimmune diseases, trauma, surgery, heart attack, cancers, and chronic inflammatory conditions."
        }
      ]
    },
    {
      "name": "Ferritin",
      "duration": "24-48 hours",
      "preparation": "Fasting recommended for accurate results",
      "image": "https://media.istockphoto.com/id/937459128/photo/blood-for-ferritin-test.jpg?s=612x612&w=0&k=20&c=4UYM3ehMGcSq1XJRPA65PpWvoRJ7NnixkxRqm0kOgIg=",
      "description": "Iron storage protein measurement for iron status assessment",
      "detailedDescription": [
        "Iron storage capacity evaluation",
        "Iron deficiency anemia diagnosis",
        "Iron overload detection",
        "Inflammation marker in some contexts",
        "Treatment monitoring"
      ],
      "keyBenefits": [
        "Early iron deficiency detection",
        "Iron overload diagnosis",
        "Anemia cause identification",
        "Treatment guidance"
      ],
      "faqs": [
        {
          "question": "What is normal ferritin level?",
          "answer": "Men: 20-500 ng/mL, Women: 20-200 ng/mL. Optimal levels may be higher. Levels below 15 indicate iron deficiency."
        },
        {
          "question": "Can ferritin be high in inflammation?",
          "answer": "Yes, ferritin is an acute phase reactant and can be elevated in inflammatory conditions even with iron deficiency."
        }
      ]
    },
    {
      "name": "IL6 Level",
      "duration": "48-72 hours",
      "preparation": "No special preparation required",
      "image": "https://images.pexels.com/photos/7089036/pexels-photo-7089036.jpeg",
      "description": "Interleukin-6 measurement for inflammation and immune response",
      "detailedDescription": [
        "Pro-inflammatory cytokine assessment",
        "Immune system activation evaluation",
        "Sepsis and severe infection monitoring",
        "Autoimmune disease activity assessment",
        "COVID-19 severity indicator"
      ],
      "keyBenefits": [
        "Severe inflammation assessment",
        "Sepsis early detection",
        "Treatment response monitoring",
        "Prognostic indicator"
      ],
      "faqs": [
        {
          "question": "When is IL6 test used?",
          "answer": "In severe infections, sepsis, autoimmune diseases, certain cancers, and recently for COVID-19 severity assessment."
        },
        {
          "question": "What does high IL6 indicate?",
          "answer": "Severe inflammation, infection, autoimmune activity, or cytokine storm in conditions like severe COVID-19."
        }
      ]
    },
    {
      "name": "PSA (PROSTATE)",
      "duration": "24-48 hours",
      "preparation": "No ejaculation for 48 hours, no vigorous exercise",
      "image": "https://media.istockphoto.com/id/1376569576/photo/blood-sample-for-analysis-of-psa-prostate-specific-antigen-profile-test-in-laboratory.jpg?s=612x612&w=0&k=20&c=t8ZKsZc8vOhzPQUFCp_ZP7WW4ysa_jMBPAafkzARMi4=",
      "description": "Prostate Specific Antigen measurement for prostate health assessment",
      "detailedDescription": [
        "Total PSA level measurement",
        "Free PSA percentage calculation",
        "Prostate cancer screening",
        "Benign prostatic hyperplasia monitoring",
        "Prostate inflammation assessment"
      ],
      "keyBenefits": [
        "Prostate cancer screening",
        "BPH monitoring",
        "Treatment response assessment",
        "Early detection capability"
      ],
      "faqs": [
        {
          "question": "When should men get PSA testing?",
          "answer": "Screening typically starts at age 50, or earlier for high-risk groups (African Americans, family history). Discuss with your doctor."
        },
        {
          "question": "What causes elevated PSA besides cancer?",
          "answer": "BPH, prostatitis, urinary tract infection, recent ejaculation, prostate exam, catheterization, and vigorous exercise."
        }
      ]
    },
    {
      "name": "RT-PCR",
      "duration": "24-48 hours",
      "preparation": "As per specific test requirements",
      "image": "https://media.istockphoto.com/id/1402547678/photo/antibody-as-a-molecular-slingshot.jpg?s=612x612&w=0&k=20&c=IDhxz3QuEI_vboehsRRhuMtQ-GOUeuMPSazsBayLqAM=",
      "description": "Reverse Transcription Polymerase Chain Reaction for RNA virus detection",
      "detailedDescription": [
        "RNA virus detection and quantification",
        "COVID-19 diagnostic testing",
        "Viral load measurement",
        "High sensitivity and specificity",
        "Early infection detection"
      ],
      "keyBenefits": [
        "Gold standard for COVID-19 diagnosis",
        "High accuracy",
        "Early detection capability",
        "Multiple pathogen detection capability"
      ],
      "faqs": [
        {
          "question": "How accurate is RT-PCR test?",
          "answer": "RT-PCR is considered the gold standard with over 95% sensitivity and specificity when properly collected and processed."
        },
        {
          "question": "How long does it take to get RT-PCR results?",
          "answer": "Typically 24-48 hours, but may vary depending on laboratory workload and transportation time."
        }
      ]
    }
  ]
},

  {
  "id": "cardiology",
  "name": "CARDIOLOGY",
  "icon": "heart",
  "description": "Comprehensive cardiac care with advanced diagnostic and interventional cardiology services",
  "image": "https://m2hospital.com/wp-content/uploads/2025/02/ECG-Test-Price.jpg",
  "details": "Our state-of-the-art cardiology department offers complete cardiac evaluation with cutting-edge technology. Equipped with advanced echocardiography, stress testing, and cardiac monitoring systems for accurate diagnosis and comprehensive heart care.",
  "keyFeatures": [
    "Advanced echocardiography with strain imaging",
    "Digital ECG systems with AI analysis",
    "Computerized treadmill stress testing",
    "Expert cardiologist interpretation",
    "Comprehensive risk assessment",
    "Personalized treatment planning"
  ],
  "subServices": [
    {
      "name": "GLS 2D Echo",
      "duration": "45-60 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/1175254260/photo/screen-of-echocardiography-machine.jpg?s=612x612&w=0&k=20&c=sBrhAd59Q8gjX4h8OItG46v9yfu0LRz-kRJKRyJGp3E=",
      "description": "Advanced echocardiography with Global Longitudinal Strain analysis for precise heart function assessment",
      "detailedDescription": [
        "Quantitative assessment of myocardial deformation using speckle tracking",
        "Early detection of subclinical heart muscle dysfunction",
        "Precise measurement of global longitudinal strain (GLS)",
        "Monitoring of chemotherapy-induced cardiotoxicity",
        "Assessment of heart function in athletes and hypertension patients",
        "Evaluation of subtle myocardial diseases before ejection fraction changes",
         "Echocardiography refers to Echo.",
  "2-dimension images of the heart are created in Echocardiography.",
  "An imaging procedure that examines the function of the different parts of the heart is known as 2D Echo.",
  "Through 2D Echo can assess the blockages, damages, blood flow rate, etc.",
  "When a disorder is related to the heart, doctors advise 2D Echo to check abnormalities in the heart.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body as no radiation is used in it."
      ],
      "keyBenefits": [
        "Early detection of heart muscle impairment before symptoms appear",
        "More sensitive than conventional ejection fraction measurement",
        "Objective quantification of myocardial function",
        "Better monitoring of chemotherapy side effects on heart",
        "Improved detection of subtle cardiac changes in athletes"
      ],
      "faqs": [
        {
          "question": "What is Global Longitudinal Strain (GLS)?",
          "answer": "GLS measures the percentage change in length of heart muscle fibers during contraction. It's a more sensitive indicator of heart function than traditional ejection fraction and can detect early-stage heart muscle problems."
        },
        {
          "question": "Who should get a GLS 2D Echo?",
          "answer": "Patients receiving chemotherapy, those with early heart failure symptoms, athletes with performance issues, hypertensive patients, and anyone needing sensitive assessment of myocardial function beyond standard echocardiography."
        },
        {
          "question": "How is GLS different from regular echocardiogram?",
          "answer": "While standard echo measures heart chamber sizes and ejection fraction, GLS uses advanced speckle tracking to measure microscopic myocardial deformation, providing earlier detection of heart muscle problems."
        }
      ]
    },
    {
      "name": "ECG",
      "duration": "15-20 mins",
      "preparation": "No special preparation required",
      "image": "https://media.istockphoto.com/id/2149642730/photo/vital-signs-monitor-digital-and-hospital-with-ekg-machine-electronic-and-medical-equipment-to.jpg?s=612x612&w=0&k=20&c=uZonPr0WW0YNT1We4L6dmFahABP3ue27EyUWs_K34mU=",
      "description": "Electrocardiogram for recording heart's electrical activity and rhythm",
      "detailedDescription": [
        "12-lead electrocardiogram recording",
        "Assessment of heart rate and rhythm",
        "Detection of arrhythmias and conduction abnormalities",
        "Identification of ischemic changes and heart attack",
        "Evaluation of chamber enlargement and hypertrophy",
        "Baseline cardiac assessment and pre-operative evaluation",
         "Monitoring of conditions that are affecting the heart is important.",
  "To check the heart’s rhythm and electrical activity, a simple test known as ECG can be done.",
  "ECG stands for Electrocardiogram",
  "ECG helps in investigating possible heart-related symptoms like dizziness, chest pain, heart pain shortness of breath, etc.",
  "ECG is a simple test that takes approximately 5-15 minutes to perform.",
  "ECG helps us to show different conditions of the heart like fast or slow heart rhythm, heart valve disease, heart defects, enlarged heart, etc.",
  "ECG is recommended by Cardiologists or any other Doctor to study the heart status.",
  "ECG is performed by qualified and trained professionals from healthcare."
      ],
      "keyBenefits": [
        "Quick and non-invasive heart rhythm assessment",
        "Immediate detection of heart attacks and ischemia",
        "Identification of various arrhythmias",
        "Essential for pre-operative cardiac clearance",
        "No radiation exposure - completely safe"
      ],
      "faqs": [
        {
          "question": "What conditions can ECG detect?",
          "answer": "ECG can detect heart attacks, arrhythmias (atrial fibrillation, tachycardia), heart block, chamber enlargement, electrolyte imbalances, pericarditis, and various other cardiac conditions."
        },
        {
          "question": "Is ECG painful or risky?",
          "answer": "No, ECG is completely painless and non-invasive. Electrodes are placed on the skin to record electrical activity. There are no risks or side effects associated with the procedure."
        },
        {
          "question": "How often should I get an ECG?",
          "answer": "Healthy adults should have baseline ECG in their 20s-30s and periodic screening after age 40. Those with heart conditions or risk factors may need more frequent monitoring as advised by their cardiologist."
        }
      ]
    },
    {
      "name": "TMT (Stress Test) - Treadmill Test",
      "duration": "60-90 mins",
      "preparation": "Fasting for 2-3 hours, comfortable clothing and shoes required",
      "image": "https://media.istockphoto.com/id/1802804602/photo/man-running-while-preforming-a-cardiovascular-stress-test.jpg?s=612x612&w=0&k=20&c=kP0NFRUszXAqmt7BeKJm1oGjl-Br7s2-9OEv-YgNkoA=",
      "description": "Exercise stress test to evaluate heart function under physical exertion",
      "detailedDescription": [
        "Gradual increase in treadmill speed and elevation following Bruce or modified Bruce protocol",
        "Continuous ECG monitoring during exercise and recovery",
        "Blood pressure monitoring at each stage",
        "Assessment of exercise capacity and functional status",
        "Detection of exercise-induced ischemia and arrhythmias",
        "Evaluation of chest pain symptoms during exertion",
         "TMT stands for Tread Mill Test. TMT test is also known as Stress Test or Tread Mill Test.",
  "TMT test helps to measure the blood circulation inside the body when a person runs on the tread mill.",
  "It is majorly done to examine how heart functions when there is physical activity done.",
  "Doctors advise Stress test when symptoms like chest pain, shortness of breath, irregular heart beat or heavy heartbeats are there.",
  "It takes only about 15–30 minutes to perform the same.",
  "It is a safe technique that does not harm the human body."
      ],
      "keyBenefits": [
        "Detection of coronary artery disease not apparent at rest",
        "Assessment of exercise tolerance and functional capacity",
        "Evaluation of heart rate and blood pressure response to exercise",
        "Guidance for cardiac rehabilitation and exercise prescription",
        "Monitoring effectiveness of cardiac medications"
      ],
      "faqs": [
        {
          "question": "What is the purpose of a treadmill stress test?",
          "answer": "TMT helps diagnose coronary artery disease, assess heart function under stress, evaluate exercise capacity, investigate exercise-induced symptoms, and determine safe exercise levels for cardiac patients."
        },
        {
          "question": "Who should avoid treadmill stress test?",
          "answer": "Patients with recent heart attack, unstable angina, severe aortic stenosis, uncontrolled arrhythmias, acute heart failure, or severe physical limitations that prevent safe exercise."
        },
        {
          "question": "What happens if I cannot complete the test?",
          "answer": "The test is stopped when target heart rate is achieved, symptoms develop, or ECG changes occur. Incomplete tests still provide valuable information, and alternative tests may be recommended."
        }
      ]
    }
  ]
},
  {
  "id": "bmd",
  "name": "BMD (BONE DENSITOMETRY)",
  "icon": "bone",
  "description": "Advanced bone mineral density testing for osteoporosis diagnosis and bone health assessment",
  image:  process.env.PUBLIC_URL + "/images/bmd.jpg",
  "details": "Our state-of-the-art Bone Densitometry facility offers precise measurement of bone mineral density using advanced DXA technology. This painless, non-invasive test provides accurate assessment of bone health and fracture risk with minimal radiation exposure.",
  "keyFeatures": [
    "Advanced DXA (Dual-energy X-ray Absorptiometry) technology",
    "Low radiation exposure - less than standard chest X-ray",
    "Precise bone mineral density measurement",
    "Quick and painless procedure",
    "Expert radiologist interpretation",
    "Comprehensive fracture risk assessment"
  ],
  // "subServices": [
  //   {
  //     "name": "Central DXA (Spine and Hip)",
  //     "duration": "15-20 mins",
  //     "preparation": "Avoid calcium supplements for 24 hours, wear metal-free clothing",
  //     "image": "https://images.pexels.com/photos/7089038/pexels-photo-7089038.jpeg",
  //     "description": "Gold standard bone density measurement of spine and hip regions",
  //     "detailedDescription": [
  //       "Precise measurement of lumbar spine bone density",
  //       "Assessment of femoral neck and total hip density",
  //       "Most accurate sites for osteoporosis diagnosis",
  //       "T-score calculation for fracture risk assessment",
  //       "Monitoring treatment effectiveness over time",
  //       "World Health Organization (WHO) standard classification"
  //     ],
  //     "keyBenefits": [
  //       "Most accurate osteoporosis diagnosis",
  //       "Gold standard for treatment monitoring",
  //       "Comprehensive fracture risk assessment",
  //       "International standard T-score calculation"
  //     ],
  //     "faqs": [
  //       {
  //         "question": "Why are spine and hip the preferred sites for BMD testing?",
  //         "answer": "The spine and hip are most susceptible to osteoporotic fractures and provide the most accurate prediction of overall fracture risk. These sites have high metabolic activity and show changes earliest."
  //       },
  //       {
  //         "question": "What do T-scores mean in bone density reports?",
  //         "answer": "Normal: Above -1.0, Osteopenia (low bone mass): -1.0 to -2.5, Osteoporosis: -2.5 or below. These scores compare your bone density to healthy young adults."
  //       },
  //       {
  //         "question": "How often should central DXA be repeated?",
  //         "answer": "Typically every 2 years for monitoring, or more frequently if starting new medications or if significant bone loss is suspected."
  //       }
  //     ]
  //   },
  //   {
  //     "name": "Forearm BMD",
  //     "duration": "10-15 mins",
  //     "preparation": "Remove wrist jewelry, wear comfortable clothing",
  //     "image": "https://images.pexels.com/photos/7089038/pexels-photo-7089038.jpeg",
  //     "description": "Bone density assessment of the forearm for specific clinical situations",
  //     "detailedDescription": [
  //       "Measurement of distal radius bone density",
  //       "Alternative site when spine/hip cannot be measured",
  //       "Useful for patients with hyperparathyroidism",
  //       "Assessment when spine has degenerative changes",
  //       "Screening in specific metabolic bone diseases",
  //       "Complementary to central DXA in complex cases"
  //     ],
  //     "keyBenefits": [
  //       "Alternative when spine/hip not measurable",
  //       "Specific utility in hyperparathyroidism",
  //       "Avoids artifacts from spinal degeneration",
  //       "Quick and convenient screening option"
  //     ],
  //     "faqs": [
  //       {
  //         "question": "When is forearm BMD specifically recommended?",
  //         "answer": "For patients with hyperparathyroidism, when spine has severe arthritis or previous surgery, when hip replacement is present, or when central DXA is not feasible."
  //       },
  //       {
  //         "question": "Is forearm BMD as accurate as spine/hip testing?",
  //         "answer": "While useful in specific situations, forearm BMD alone may not provide the complete fracture risk picture. It's often used alongside or when central sites cannot be measured."
  //       },
  //       {
  //         "question": "Which arm is typically used for forearm BMD?",
  //         "answer": "The non-dominant arm is usually measured unless there's a specific reason to test the dominant arm or both arms for comparison."
  //       }
  //     ]
  //   },
  //   {
  //     "name": "Whole Body BMD with Body Composition",
  //     "duration": "20-25 mins",
  //     "preparation": "Fasting for 4 hours recommended, wear light clothing without metal",
  //     "image": "https://images.pexels.com/photos/7089038/pexels-photo-7089038.jpeg",
  //     "description": "Comprehensive bone density assessment with detailed body composition analysis",
  //     "detailedDescription": [
  //       "Complete skeletal bone mineral density assessment",
  //       "Lean muscle mass measurement and distribution",
  //       "Body fat percentage and distribution analysis",
  //       "Visceral fat quantification",
  //       "Pediatric bone health assessment",
  //       "Athlete performance and nutrition monitoring"
  //     ],
  //     "keyBenefits": [
  //       "Comprehensive skeletal health assessment",
  //       "Detailed body composition analysis",
  //       "Visceral fat risk assessment",
  //       "Ideal for athletes and metabolic studies"
  //     ],
  //     "faqs": [
  //       {
  //         "question": "Who benefits from whole body BMD with body composition?",
  //         "answer": "Athletes monitoring training effects, patients with metabolic disorders, individuals in weight management programs, pediatric growth assessments, and comprehensive health evaluations."
  //       },
  //       {
  //         "question": "What is visceral fat and why is it important?",
  //         "answer": "Visceral fat is deep abdominal fat surrounding organs, associated with increased risk of heart disease, diabetes, and metabolic syndrome. This test provides precise measurement unavailable from standard methods."
  //       },
  //       {
  //         "question": "Can children undergo whole body BMD?",
  //         "answer": "Yes, with appropriate pediatric protocols and interpretation. It's valuable for growth disorders, nutritional assessments, and certain medical conditions affecting bone development."
  //       }
  //     ]
  //   }
  // ]
},
 {
  "id": "speciality-clinic",
  "name": "SPECIALITY CLINIC",
  "icon": "stethoscope",
  "description": "Comprehensive multi-specialty healthcare services with expert medical consultations and personalized treatment plans",
  "image": "https://media.istockphoto.com/id/1137375801/photo/doctor-in-gown-uniform-with-stethoscope-standing-and-fold-his-arms-over-the-chest-on-opd.jpg?s=612x612&w=0&k=20&c=-OYu7guZP87qnBH0vk-2dNfRcyXtas8PEiGLXediAvw=",
  "details": "Our specialty clinic brings together renowned medical experts from various fields to provide integrated healthcare solutions. With state-of-the-art facilities and patient-centered approach, we ensure comprehensive medical care for all your health needs.",
  "keyFeatures": [
    "Expert specialist consultations",
    "Multi-disciplinary approach",
    "Advanced diagnostic support",
    "Personalized treatment plans",
    "Follow-up and continuity of care",
    "Integrated healthcare services"
  ],
  "subServices": [
   {
  "name": "Radiology",
  "duration": "15-60 mins",
  "preparation": "Follow specific instructions based on the imaging test; bring previous scans and reports if available",
  image:  process.env.PUBLIC_URL + "/images/radiology.jpg",
  "description": "Medical imaging services to diagnose and evaluate various body conditions using advanced imaging techniques",
  "detailedDescription": [
    "X-Ray imaging for bones and chest evaluation",
    "Ultrasound (USG) for abdominal, pelvic, and musculoskeletal assessment",
    "CT Scan for detailed cross-sectional imaging of body organs",
    "MRI for soft tissue, brain, spine, and joint evaluation",
    "Doppler studies to assess blood flow in vessels",
    "Specialized scans like 2D Echo, TMT, and fetal imaging for pregnancy assessment"
  ],
  "keyBenefits": [
    "Non-invasive diagnostic evaluation",
    "Early detection of diseases and abnormalities",
    "Guides treatment and surgical planning",
    "Safe imaging options with minimal or no radiation for certain tests"
  ],
  "faqs": [
    {
      "question": "What types of imaging tests are available in Radiology?",
      "answer": "X-Ray, Ultrasound (USG), CT Scan, MRI, Doppler studies, 2D Echocardiography, Treadmill Test, and specialized pregnancy scans like USG Abdomen Pelvis, 3D/4D and Doppler."
    },
    {
      "question": "Is Radiology safe?",
      "answer": "Yes, most imaging procedures are safe with minimal radiation exposure. Ultrasound and MRI use no ionizing radiation, making them very safe."
    },
    {
      "question": "Do I need any preparation before radiology tests?",
      "answer": "Preparation depends on the test. For example, fasting may be required for certain CT or ultrasound scans. Always follow the specific instructions provided by the radiology department."
    },
    {
      "question": "How long does a radiology test take?",
      "answer": "It depends on the procedure: X-Ray or Ultrasound may take 15-30 minutes, CT or MRI 30-60 minutes, and specialized studies may take longer."
    }
  ]
},

    {
      "name": "General Physician",
      "duration": "20-30 mins",
      "preparation": "Bring previous medical records and medications list",
      "image": "https://media.istockphoto.com/id/530284279/photo/checking-blood-pressure.jpg?s=612x612&w=0&k=20&c=KJdCdv6vs7tva5BXefiF6MfKn2JHwo9iO25_h2CbqI8=",
      "description": "Comprehensive primary care for general health issues and chronic disease management",
      "detailedDescription": [
        "Diagnosis and treatment of common illnesses and infections",
        "Management of chronic conditions like hypertension and diabetes",
        "Preventive health screenings and vaccinations",
        "Health risk assessments and lifestyle counseling",
        "Referrals to appropriate specialists when needed",
        "Comprehensive physical examinations and health maintenance"
      ],
      "keyBenefits": [
        "First point of contact for all health concerns",
        "Holistic approach to patient care",
        "Coordination with multiple specialists",
        "Continuity of care and long-term health management"
      ],
      "faqs": [
        {
          "question": "When should I see a General Physician?",
          "answer": "For routine check-ups, common illnesses, chronic disease management, preventive care, and as the first step for any health concern that requires specialist referral."
        },
        {
          "question": "What conditions do General Physicians treat?",
          "answer": "Fever, infections, hypertension, diabetes, respiratory issues, digestive problems, minor injuries, and overall health maintenance and prevention."
        }
      ]
    },
    {
      "name": "Orthopaedic Surgeon",
      "duration": "20-30 mins",
      "preparation": "Bring X-rays/MRI reports and wear comfortable clothing",
      "image": "https://media.istockphoto.com/id/1488591082/photo/female-doctor-who-is-explaining-the-treatment-method-of-the-knee-joint-to-the-woman-patient.jpg?s=612x612&w=0&k=20&c=k1rcw3GG2Kfw75oX7o4z1IkstiHfORlFS6W7fp5svHE=",
      "description": "Expert care for bone, joint, and musculoskeletal disorders and injuries",
      "detailedDescription": [
        "Diagnosis and treatment of bone fractures and joint injuries",
        "Management of arthritis and degenerative joint diseases",
        "Sports injury evaluation and rehabilitation",
        "Joint replacement surgery planning and follow-up",
        "Spinal disorders and back pain management",
        "Minimally invasive orthopedic procedures"
      ],
      "keyBenefits": [
        "Comprehensive musculoskeletal care",
        "Advanced surgical and non-surgical treatments",
        "Sports medicine expertise",
        "Joint preservation and replacement options"
      ],
      "faqs": [
        {
          "question": "What symptoms require an Orthopaedic consultation?",
          "answer": "Joint pain, swelling, limited mobility, bone fractures, sports injuries, back pain, arthritis symptoms, and any musculoskeletal discomfort affecting daily activities."
        },
        {
          "question": "Do all orthopaedic problems require surgery?",
          "answer": "No, many conditions can be managed with conservative treatments like physiotherapy, medications, injections, and lifestyle modifications. Surgery is considered only when necessary."
        }
      ]
    },
    {
      "name": "Neuro and Spine Surgeon",
      "duration": "30-45 mins",
      "preparation": "Bring all MRI/CT scans and previous treatment records",
      "image": "https://media.istockphoto.com/id/1220276649/photo/doctor-x-ray-brain.jpg?s=612x612&w=0&k=20&c=NzCc-oN7vwuUUxb0bCMSZ_4jKKHlf7_wLb9bTfKRaIQ=",
      "description": "Surgical expertise for brain, spine, and nervous system disorders",
      "detailedDescription": [
        "Brain tumor surgery and neuro-oncology",
        "Spinal disc surgery and decompression procedures",
        "Minimally invasive spine surgeries",
        "Treatment of spinal fractures and deformities",
        "Peripheral nerve surgery",
        "Complex spinal reconstruction surgeries"
      ],
      "keyBenefits": [
        "Advanced neurosurgical techniques",
        "Minimally invasive options",
        "Comprehensive brain and spine care",
        "Multidisciplinary surgical planning"
      ],
      "faqs": [
        {
          "question": "What conditions require Neuro-spine surgery consultation?",
          "answer": "Severe disc herniation, spinal stenosis, brain tumors, spinal tumors, traumatic brain or spine injuries, and conditions not responding to conservative treatment."
        },
        {
          "question": "Are brain and spine surgeries risky?",
          "answer": "While all surgeries carry some risk, modern techniques including minimally invasive and navigation-guided surgeries have significantly improved safety and outcomes."
        }
      ]
    },
    {
      "name": "Diabetologist",
      "duration": "30-45 mins",
      "preparation": "Bring blood sugar records and current medications",
      "image": "https://media.istockphoto.com/id/993401446/photo/girl-teenager-measures-blood-sugar-level.jpg?s=612x612&w=0&k=20&c=4PdBg3LX-3X5WEtbzF_8KlCiK9QUcvliYrNkCltmF-w=",
      "description": "Specialized care for diabetes management and metabolic disorders",
      "detailedDescription": [
        "Comprehensive diabetes diagnosis and type classification",
        "Personalized insulin and medication management",
        "Diabetes complication screening and prevention",
        "Gestational diabetes management",
        "Continuous glucose monitoring guidance",
        "Diabetes education and lifestyle modification planning"
      ],
      "keyBenefits": [
        "Specialized diabetes expertise",
        "Comprehensive complication prevention",
        "Latest diabetes technology guidance",
        "Lifelong diabetes management support"
      ],
      "faqs": [
        {
          "question": "When should I see a Diabetologist instead of a General Physician?",
          "answer": "When diabetes is difficult to control, when complications develop, during pregnancy, or when you need specialized insulin pump or continuous glucose monitoring management."
        },
        {
          "question": "What is the target HbA1c for diabetics?",
          "answer": "Generally below 7%, but targets are individualized based on age, diabetes duration, and presence of complications."
        }
      ]
    },
    {
      "name": "Physician",
      "duration": "20-30 mins",
      "preparation": "Bring all medical records and current medication list",
      "image": "https://media.istockphoto.com/id/1437830105/photo/cropped-shot-of-a-female-nurse-hold-her-senior-patients-hand-giving-support-doctor-helping.jpg?s=612x612&w=0&k=20&c=oKR-00at4oXr4tY5IxzqsswaLaaPsPRkdw2MJbYHWgA=",
      "description": "Internal medicine specialist for complex adult medical conditions",
      "detailedDescription": [
        "Management of complex multi-system diseases",
        "Hospital care and critical illness management",
        "Diagnosis of rare and complicated medical conditions",
        "Coordination of care between multiple specialists",
        "Pre-operative medical optimization",
        "Comprehensive geriatric care"
      ],
      "keyBenefits": [
        "Expertise in complex medical diagnoses",
        "Hospital and critical care management",
        "Multi-system disease coordination",
        "Comprehensive adult medical care"
      ],
      "faqs": [
        {
          "question": "What is the difference between Physician and General Physician?",
          "answer": "Physicians (Internists) specialize in complex adult medical conditions and hospital care, while General Physicians provide broader primary care including pediatrics and basic care."
        },
        {
          "question": "When should I see a Physician?",
          "answer": "For complex medical problems, multiple coexisting conditions, unclear diagnoses, or when referred by your primary doctor for specialized medical management."
        }
      ]
    }, 
    {
      "name": "Dentist",
      "duration": "30-60 mins",
      "preparation": "Brush teeth before appointment, bring dental records if any",
      "image": "https://media.istockphoto.com/id/2151876182/photo/dentist-drilling-in-teeth-of-the-patient.jpg?s=612x612&w=0&k=20&c=IpReurL7X5xy5nFjalwQPsradTW5g9HkzOLYqpviHkY=",
      "description": "Comprehensive oral health care and dental treatments",
      "detailedDescription": [
        "Routine dental check-ups and cleanings",
        "Cavity treatment and fillings",
        "Root canal treatments",
        "Dental crowns and bridges",
        "Teeth whitening and cosmetic dentistry",
        "Oral health education and prevention"
      ],
      "keyBenefits": [
        "Complete oral health maintenance",
        "Preventive dental care",
        "Cosmetic and restorative options",
        "Emergency dental services"
      ],
      "faqs": [
        {
          "question": "How often should I visit the dentist?",
          "answer": "Every 6 months for routine check-ups and cleaning, or more frequently if you have specific dental issues or conditions."
        },
        {
          "question": "What are signs I need to see a dentist?",
          "answer": "Tooth pain, bleeding gums, tooth sensitivity, bad breath, mouth sores, or any changes in your oral health that concern you."
        }
      ]
    },
  ]
}
];
